// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:07:43.396Z
// Property: Chesapeake Pointe (ID: 6767906449166313)
// Collections: 31 amenities, 20 floorplans (live), 27 photos, 83 POIs, 4 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166313",
  "property_external_id": "30946",
  "property_zillow_url": "https://www.zillow.com/apartments/chesapeake-va/chesapeake-pointe/5XtPTF/",
  "property_apartments_url": "https://www.apartments.com/chesapeake-pointe-chesapeake-va/ftb653r/",
  "property_google_business_url": "https://www.google.com/maps/place/Chesapeake+Pointe/data=!4m2!3m1!1s0x0:0x6674ae27100a39d?sa=X&ved=2ahUKEwiBvaOjlLiSAxXvnGoFHXVHJAIQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "chesapeake-pointe",
  "property_name": "Chesapeake Pointe",
  "property_website_url": "https://www.livechesapeakepointe.com/",
  "property_domain": "https://www.livechesapeakepointe.com/",
  "property_address": "3537 Towne Point Road",
  "property_full_address": "3537 Towne Point Rd, Chesapeake, VA 23321",
  "property_address_1": "3537 Towne Point Rd",
  "property_address_2": null,
  "property_address_city": "Chesapeake",
  "property_address_state": "VA",
  "property_address_zip_full": "23703-2903",
  "property_address_zip": "23321",
  "property_address_country": "US",
  "property_address_county": "Chesapeake",
  "property_neighborhood_address": "Western Branch North",
  "property_address_latitude": "36.866197",
  "property_address_longitude": "-76.4031554",
  "property_email": "chesapeakepointe@aionmanagement.com",
  "property_phone": "(757) 483-1444",
  "property_call_tracking_phone": "844-542-1734",
  "property_company_name": "AION Management ",
  "property_company_url": "https://aionmanagement.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Chesapeake Pointe, where comfort meets convenience in the heart of Chesapeake, VA. Choose from spacious one, two, or three-bedroom floor plans, all designed with upgraded kitchens and cozy amenities. Enjoy a lifestyle enhanced by a fitness center, pet-friendly spaces, and outdoor areas perfect for relaxation. Find your new home today!",
  "property_long_description": "Welcome to Chesapeake Pointe, the perfect apartment community nestled in Chesapeake, VA, where comfort and convenience meet. Our thoughtfully designed floor plans include one, two, and three-bedroom options, catering to a variety of lifestyles and preferences. Experience exceptional living with a host of amenities that enrich your home life. Enjoy vibrant resident activities, a fully equipped fitness center, and a refreshing swimming pool to unwind after a busy day.\n\nAt Chesapeake Pointe, we prioritize your convenience with features like an online resident portal, flexible rent payments, and 24-hour emergency maintenance. Our pet-friendly community welcomes your furry friends, complete with a dedicated dog park for them to play and socialize. Families will enjoy our playground and picnic areas with grilling stations, making it easy to create cherished memories with neighbors and loved ones.\n\nSituated just a short stroll from public transportation, our location is ideal for commuters and adventurers alike. With added amenities like high-speed internet, on-site parking, and laundry facilities, you'll feel right at home. Take advantage of short-term leases, updated kitchens, and wall-to-wall carpeting for added comfort.\n\nJoin us at Chesapeake Pointe and discover a lifestyle that blends relaxation and activity seamlessly. From townhomes to our beautifully landscaped courtyard, there’s something for everyone. Find your new home today—browse our availability or schedule a tour to visit our community! Your perfect living experience awaits at Chesapeake Pointe!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-a15c-70d5-ad2c-e759ec9c5823.webp",
  "property_featured_image_media": {
    "alt_text": "Sparkling outdoor swimming pool with lounge chairs and a playground in the background.",
    "public_id": "019fcdf3-a15c-70d5-ad2c-e759ec9c5823",
    "storage_key": "property/6767906449166313/019fcdf3-a15c-70d5-ad2c-e759ec9c5823.webp",
    "width": 1920,
    "height": 1282
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "404",
  "property_year_built": "1971",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "99.5049504950495",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Maximum 2 pets per apartment, each up to 100 lb.",
  "property_pet_policy_description": "Cats and dogs are welcome. Maximum 2 pets per apartment, each up to 100 lb. One-time non‑refundable fee: $300. Monthly pet rent: $50 for one pet, $75 for two pets.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://chesapeakepointeva.loftliving.com/login",
  "property_apply_now_url": "https://www.livechesapeakepointe.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0268-2d77-7358-afbb-5aaa8da9c553.webp",
  "property_primary_logo_media": {
    "alt_text": "Chesapeake Pointe Apartment Homes logo",
    "public_id": "019d0268-2d77-7358-afbb-5aaa8da9c553",
    "storage_key": "property/6767906449166313/019d0268-2d77-7358-afbb-5aaa8da9c553.webp",
    "width": 300,
    "height": 125
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0268-3833-7463-a547-aa2ed84bbd25.webp",
  "property_secondary_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0268-3833-7463-a547-aa2ed84bbd25",
    "storage_key": "property/6767906449166313/019d0268-3833-7463-a547-aa2ed84bbd25.webp",
    "width": 598,
    "height": 250
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0268-5258-715c-9e1a-e2a6a416ca18.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Chesapeake Pointe Apartment Homes logo",
    "public_id": "019d0268-5258-715c-9e1a-e2a6a416ca18",
    "storage_key": "property/6767906449166313/019d0268-5258-715c-9e1a-e2a6a416ca18.webp",
    "width": 300,
    "height": 125
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0268-5c9d-746a-9371-e3734e518cce.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Chesapeake Pointe Apartment Homes logo",
    "public_id": "019d0268-5c9d-746a-9371-e3734e518cce",
    "storage_key": "property/6767906449166313/019d0268-5c9d-746a-9371-e3734e518cce.webp",
    "width": 300,
    "height": 125
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 1.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1.5",
  "property_sqft_range": "682 - 1100",
  "property_sqft_min": "682",
  "property_sqft_max": "1100",
  "property_price_range": "1267 - 2247",
  "property_price_min": "1267",
  "property_price_max": "2247",
  "property_available_units": 2,
  "property_facebook_url": "https://www.facebook.com/livechesapeakepointe/",
  "property_instagram_url": "https://www.instagram.com/livechesapeakepointe",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJi27CZXOfuokRnaMAceJKZwY",
  "property_youtube_url": "https://www.youtube.com/watch?v=O0N7kK-2rU0",
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_loc=Chesapeake%2C+VA",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Chesapeake Pointe",
  "property_home_romance_title": "Embrace the Joy of Living in Your Ideal Apartment Community",
  "property_home_amenities_blurb": "Welcome to Chesapeake Pointe, where comfort meets convenience in the heart of Chesapeake, VA. Our thoughtfully designed one, two, and three-bedroom apartments boast premium amenities, including a sparkling swimming pool, fitness center, and pet-friendly spaces. Enjoy the vibrant resident activities and modern features that make this community truly exceptional. ",
  "property_home_floorplans_blurb": "At Chesapeake Pointe in the heart of Chesapeake, VA, we offer thoughtfully designed one, two, and three-bedroom apartments that cater to your unique lifestyle. With spacious layouts and modern finishes, your dream home awaits. Browse our available options today and envision your new beginning in comfort and style.",
  "property_home_gallery_blurb": "At Chesapeake Pointe in Chesapeake, VA, spacious one, two, and three-bedroom apartments await your personal touch. Enjoy vibrant resident activities, pet-friendly spaces, and modern amenities like a fitness center and sparkling swimming pool. Picture yourself living here, surrounded by comfort and convenience—where every day feels like a getaway!",
  "property_home_neighborhood_blurb": "Welcome to Chesapeake Pointe, where comfort meets convenience in the heart of Chesapeake, VA. With spacious one, two, and three-bedroom floor plans, life here flows effortlessly. Immerse yourself in local culture with attractions like the Chesapeake Arboretum, Historic Norfolk, and Tidewater Community College, all just moments from your door.",
  "property_home_reviews_blurb": "At Chesapeake Pointe in Chesapeake, VA, residents rave about the welcoming atmosphere and exceptional service. With one resident noting, “the whole entire staff team are friendly and very professional,\" our community promises a delightful living experience. Experience comfort, convenience, and camaraderie—your perfect home awaits!",
  "property_neighborhood_blurb": "Chesapeake Pointe, nestled in vibrant Chesapeake, VA, offers more than stylish one, two, and three-bedroom apartments. Enjoy nearby gems like the Chesapeake Arboretum, the Chesapeake City Park, and the diverse offerings at Tidewater Community College. Engage with your community and see what treasures surround our friendly neighborhood!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Chesapeake Pointe in vibrant Chesapeake, VA, our pet-friendly community seamlessly blends comfort and convenience. Choose from spacious one to three-bedroom floor plans, enjoy a refreshing swim, or unwind at the yoga studio. With resident activities and a playground, there's something for everyone. Join us and elevate your lifestyle today!",
  "property_applynow_blurb": "At Chesapeake Pointe in vibrant Chesapeake, VA, you’ll find a variety of floor plans, from cozy one-bedrooms to spacious three-bedrooms, perfect for any lifestyle. Enjoy an array of amenities, including a refreshing swimming pool, dog park, fitness center, and resident activities. Lease your new home online today!",
  "property_contactus_blurb": "At Chesapeake Pointe in Chesapeake, VA, we offer thoughtfully designed one, two, and three-bedroom floor plans tailored to fit your lifestyle. Each space is crafted for comfort and convenience. Have questions? Our leasing team is eager to assist you—reach out today and let’s make your new home a reality!",
  "property_faqs_blurb": "At Chesapeake Pointe in beautiful Chesapeake, VA, our diverse floor plans cater to every lifestyle, offering one, two, and three-bedroom apartments designed for comfort and convenience. Curious about our community? Browse our FAQs page for insightful answers to help you find your perfect home at Chesapeake Pointe.",
  "property_floorplans_blurb": "At Chesapeake Pointe in vibrant Chesapeake, VA, our diverse floor plans cater to every lifestyle. From cozy one-bedroom retreats to spacious three-bedroom residences, each layout offers comfort and style. Uncover the perfect apartment home tailored just for you—browse our available floor plans today and embrace your new beginning!",
  "property_gallery_blurb": "At Chesapeake Pointe in Chesapeake, VA, picture the perfect blend of comfort and community. Choose from spacious one to three-bedroom floor plans, all while enjoying amenities like a sparkling swimming pool, fitness center, and inviting dog park. Join us and embrace a lifestyle of relaxation and engagement!",
  "property_interactivemap_blurb": "At Chesapeake Pointe in beautiful Chesapeake, VA, comfort meets convenience with one to three-bedroom apartments tailored for your lifestyle. Enjoy pet-friendly amenities, a refreshing swimming pool, a fitness center, and engaging resident activities. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Chesapeake Pointe in beautiful Chesapeake, VA, your furry friends are cherished members of the family. With spacious apartments accommodating up to two pets, our community invites you to create memories with your dogs and cats in a serene environment, complete with walking pathways and play areas designed just for them.",
  "property_referafriend_blurb": "At Chesapeake Pointe in vibrant Chesapeake, VA, our diverse floor plans—from cozy one-bedroom to spacious three-bedroom apartments—offer the perfect home for everyone. Share the joy of community living; refer a friend today and enrich your neighborhood with great friendships! Your ideal lifestyle awaits at Chesapeake Pointe.",
  "property_residentaccess_blurb": "At Chesapeake Pointe in charming Chesapeake, VA, our thoughtfully designed one, two, and three-bedroom floor plans cater to your lifestyle. Maximize your convenience—log into our resident portal to effortlessly pay rent, schedule maintenance, and enjoy a seamless living experience. Welcome home to comfort and community!",
  "property_reviews_blurb": "At Chesapeake Pointe in vibrant Chesapeake, VA, our residents celebrate a warm and inviting atmosphere. One happy tenant shares, \"The staff is always willing to assist in any way,\" reflecting the genuine care that defines our community. Experience a place where comfort and connection thrive—you'll feel right at home!",
  "property_created_at": "1757004910526",
  "property_scheduletour_blurb": "At Chesapeake Pointe in beautiful Chesapeake, VA, our versatile floor plans—ranging from cozy one-bedroom to spacious three-bedroom apartments—accommodate every lifestyle. Experience the vibrant community that our residents love by scheduling a tour today. Let their testimonials inspire your new beginning at Chesapeake Pointe!",
  "property_thankyou_blurb": "Thank you for reaching out to Chesapeake Pointe in beautiful Chesapeake, VA! With thoughtfully designed one, two, and three-bedroom apartments, we cater to your unique lifestyle. Stay tuned for our team to connect—exciting possibilities await you at your next home sweet home!",
  "property_virtualtours_blurb": "Welcome to Chesapeake Pointe in beautiful Chesapeake, VA! Our thoughtfully designed one, two, and three-bedroom apartments offer comfort and style for every lifestyle. Take a virtual tour today and experience the inviting atmosphere and modern amenities that await you in your future home!",
  "property_copyright": "2025 All Rights Reserved. Chesapeake Pointe",
  "property_seo_title_home": "Chesapeake Pointe |  Apartments in Chesapeake, VA",
  "property_seo_description_home": "Experience life at Chesapeake Pointe! Choose from diverse floor plans with top-notch amenities, from a fitness center to dog parks. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Chesapeake, VA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Chesapeake Pointe in Chesapeake, VA. Choose from spacious one, two, or three-bedroom floor plans tailored for your lifestyle.",
  "property_seo_title_amenities": "Amenities | Chesapeake, VA Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Chesapeake Pointe in Chesapeake, VA! Enjoy pet-friendly living with top-notch amenities, from a fitness center to a serene dog park. Join us today!",
  "property_seo_title_gallery": "Gallery | Apartments in Chesapeake, VA",
  "property_seo_description_gallery": "Discover Chesapeake Pointe in Chesapeake, VA! Explore beautiful photos, top-notch amenities, and spacious floor plans for your new home.",
  "property_seo_title_virtualtours": "Virtual Tours | Chesapeake Pointe Apartments",
  "property_seo_description_virtualtours": "Experience Chesapeake Pointe in VA! Take a virtual tour of our stylish one, two, and three-bedroom apartments. Your new home awaits—step inside today!",
  "property_seo_title_interactivemap": "Interactive Map | Chesapeake Pointe Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Chesapeake Pointe! Explore our interactive map for 1, 2, and 3-bedroom apartments with top amenities in Chesapeake, VA.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Chesapeake, VA",
  "property_seo_description_neighborhood": "Uncover Chesapeake Pointe’s vibrant neighborhood in Chesapeake, VA! Find local favorites, hidden gems, and nearby attractions just waiting for you to explore.",
  "property_seo_title_contact": "Contact Us | Chesapeake Pointe",
  "property_seo_description_contact": "Reach out to our leasing team at Chesapeake Pointe in Chesapeake, VA! Inquire about our one, two, and three-bedroom floor plans and find your perfect home.",
  "property_seo_title_faqs": "FAQs | Apartments in Chesapeake, VA",
  "property_seo_description_faqs": "Uncover answers at Chesapeake Pointe! From lease options to amenities, our FAQs page guides you through our vibrant community in Chesapeake, VA.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Chesapeake, VA",
  "property_seo_description_reviews": "Discover Chesapeake Pointe in VA! Read resident reviews to see why our pet-friendly apartments with great amenities are your ideal home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Chesapeake, VA",
  "property_seo_description_applynow": "Discover modern living at Chesapeake Pointe, VA. Enjoy spacious floor plans, a pool, fitness center, and pet-friendly amenities. Lease online!",
  "property_seo_title_residentaccess": "Resident Access | Chesapeake Pointe",
  "property_seo_description_residentaccess": "Seamlessly manage life at Chesapeake Pointe! Log in to your resident portal for convenient rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Chesapeake Pointe",
  "property_seo_description_referafriend": "Great friends make great neighbors at Chesapeake Pointe! Refer a friend today and experience vibrant living in beautiful Chesapeake, VA. Join our community!",
  "property_seo_title_scheduletour": "Schedule a Tour | Chesapeake Pointe",
  "property_seo_description_scheduletour": "Experience life at Chesapeake Pointe in Chesapeake, VA. Schedule your tour today and discover modern living, serene surroundings, and friendly neighbors!",
  "property_seo_title_privacy": "Privacy Policy | Chesapeake Pointe",
  "property_seo_description_privacy": "At Chesapeake Pointe, your privacy is our priority. Review our policy to see how we safeguard your personal information.",
  "property_seo_title_accessibility": "Website Accessibility | Chesapeake Pointe",
  "property_seo_description_accessibility": "At Chesapeake Pointe in Chesapeake, VA, we're committed to digital inclusion and accessibility for all. Join our community and experience a welcoming home!",
  "property_seo_title_sitemap": "Sitemap | Chesapeake Pointe",
  "property_seo_description_sitemap": "Discover Chesapeake Pointe! Access our sitemap for amenities, floor plans, and everything we offer in Chesapeake, VA.",
  "property_seo_title_thankyou": "Thank You | Chesapeake Pointe",
  "property_seo_description_thankyou": "Thank you for contacting Chesapeake Pointe! We'll connect soon to answer all your questions about your future home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Chesapeake, VA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293670369",
  "amenities": [
    {
      "id": "custom_d9ed59f6-aa86-4a63-93ef-abffb74d4cd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aba2d999-9cae-4ded-a87c-ac493a9a8712",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_075fc04b-8305-4a91-8648-8fc10a8b35f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4c990314-bd3d-432d-ba0e-7b38bded43ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payment & Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_868cfa94-53b2-4748-95a1-151a244bb64e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_85a61a18-cb28-48ce-8e80-9665710b7209",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management Office",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_34a1c014-65e4-401d-a576-2cbf072db63a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "Pet-Friendly",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8599594b-c6c9-4b75-a6bd-e636ae2ff28f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "Short-Term Leases Available",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_86a96191-150c-41fb-9dbd-699c00cea315",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "Yoga Studio",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4af1204c-07e5-48f1-9fa0-0d5e13a2586f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1bbb4aec-c3a3-4dc1-a2cc-6c94215273c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "Central Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c381c14e-b746-44d1-8c91-5be3b260870f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_914496ea-ea7c-437a-9fbc-84d15699bd47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "High-Speed Internet Available",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3bbe9e95-047e-413d-a92c-b4f1922cba8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_45dcb54a-fc56-48ae-bef7-a29cb058517e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "Microwave*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f55acb0b-71e6-410a-988b-aa9376fb94af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "Private Balcony or Patio",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d5c657ae-63cd-4f1d-9f36-b98116b7b81e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Bathrooms*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7ff23295-87da-4e7b-8238-e776c7ed7e88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "Townhomes Available*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f0f76f69-3048-41ed-8920-b0161eadb1bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "Upgraded Kitchens*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a433396b-ec73-4d94-a4ea-7612986ab99b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "Vinyl Hardwood Plank Flooring*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c0fb124d-abab-40b8-af73-1fada392566e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "Washer & Dryer in Home*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_20939291-92aa-4b16-962c-88d47ca5baaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "Close to Norfolk Naval Station",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_130c9aed-a0f4-4dbb-a44b-0d39f4df6d37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "Near Churchland & Western Branch School Districts",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_efbc9351-6d79-415e-9822-b4137b36c98c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "Near Old Dominion University",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b0f4b90b-c5cc-40c0-a3c1-8a34c9f1871a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "Walk to Public Transport",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ac4c3d09-2671-4b38-b38e-aecca36035e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "2 Dog Parks",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a806e20c-b7d1-45d8-96e0-e96fcf4bac7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "2 Playgrounds",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a59d908f-e815-4c0d-a6de-18780584d307",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "2 Swimming Pools",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_13ef1e79-e5fe-4234-9084-76961242a97a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "Free On-Site and Guest Parking",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0dea095a-a59e-4b8f-9f77-105bb28ec212",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "Grilling Area",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4884e3c4-7dab-4e38-a9c7-ba7a050aa785",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "external_id": "false",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_c10cd6b4-75a2-405a-9e47-1ffd2d62debc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-b0ef-767d-9f1d-0c5ff8d63dc4.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, and black appliances.",
        "public_id": "019fcdf3-b0ef-767d-9f1d-0c5ff8d63dc4",
        "storage_key": "property/6767906449166313/019fcdf3-b0ef-767d-9f1d-0c5ff8d63dc4.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Renovated kitchen with white cabinets and black appliances",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, and black appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/Chesapeake+Pointe-POI-008.jpg"
    },
    {
      "id": "custom_a8970b76-915e-481d-8b4e-d3dc91f235da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-b0f9-75ef-bc35-bd57dc89913e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, black appliances, and granite countertops.",
        "public_id": "019fcdf3-b0f9-75ef-bc35-bd57dc89913e",
        "storage_key": "property/6767906449166313/019fcdf3-b0f9-75ef-bc35-bd57dc89913e.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with white cabinetry, granite countertops, and stainless steel sink and appliances.",
      "link": "false",
      "alt_text": "Bright white apartment kitchen with granite countertops, white cabinets, stainless sink, and black appliances at Chesapeake Pointe, offers Apartments for Rent in Chesapeake, VA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/5767906449162442/6767906449166313/bbe23e4bda56b3ca4bcf120fefde4ef3.jpg"
    },
    {
      "id": "custom_11397d14-312c-4402-8c05-c3e29bf70e64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-b16c-75ed-ab5c-5488f99790f6.webp",
      "image_media": {
        "alt_text": "Living room and dining room with white sofa, armchair, coffee table, and dining table.",
        "public_id": "019fcdf3-b16c-75ed-ab5c-5488f99790f6",
        "storage_key": "property/6767906449166313/019fcdf3-b16c-75ed-ab5c-5488f99790f6.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with comfortable seating and a large dining table, perfect for entertaining guests.",
      "link": "false",
      "alt_text": "Living room in an apartment with a white sofa, armchairs, a TV, and a dining area near sliding glass doors at Chesapeake Pointe, offers Apartments for Rent in Chesapeake, VA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/5767906449162442/6767906449166313/ce257adc72fcc43c5beed2f393218703.jpg"
    },
    {
      "id": "custom_f4636911-6838-420c-8b4d-4365b586339d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-b127-74cd-b702-4d530700e393.webp",
      "image_media": {
        "alt_text": "Living room and dining area with kitchen in background.",
        "public_id": "019fcdf3-b127-74cd-b702-4d530700e393",
        "storage_key": "property/6767906449166313/019fcdf3-b127-74cd-b702-4d530700e393.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Open-concept living space in an apartment with a dining set, white cabinetry, and neutral decor.",
      "link": "false",
      "alt_text": "Open-concept living area with dining table, kitchen, and sofa at Chesapeake Pointe, offers Apartments for Rent in Chesapeake, VA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/5767906449162442/6767906449166313/a32e9a08c3738b2010e52ef0dc40471c.jpg"
    },
    {
      "id": "custom_05511fff-1d1b-435a-b7c9-f9d364414292",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-bc81-76a9-af86-afcce4cff711.webp",
      "image_media": {
        "alt_text": "Bedroom with queen-size bed, nightstand, window, and closet.",
        "public_id": "019fcdf3-bc81-76a9-af86-afcce4cff711",
        "storage_key": "property/6767906449166313/019fcdf3-bc81-76a9-af86-afcce4cff711.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Neutral, well-lit bedroom in a modern apartment with a wooden headboard, nightstand, and closet.",
      "link": "false",
      "alt_text": "Bedroom in a modern apartment with gray walls, a wooden headboard, striped bedding, and a window at Chesapeake Pointe, offers Apartments for Rent in Chesapeake, VA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/5767906449162442/6767906449166313/9a6c079f8dcf3717fb65ac4cb5d4aa53.jpg"
    },
    {
      "id": "custom_2757437b-f5c9-4b2a-b2e2-ac6ac86a9ac6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-bcfc-779e-8bba-8c79bc15571f.webp",
      "image_media": {
        "alt_text": "Stacked washer and dryer in a closet.",
        "public_id": "019fcdf3-bcfc-779e-8bba-8c79bc15571f",
        "storage_key": "property/6767906449166313/019fcdf3-bcfc-779e-8bba-8c79bc15571f.webp",
        "width": 891,
        "height": 1335
      },
      "title": "Apartment",
      "description": "In-unit laundry with a stacked washer and dryer tucked under a shelf in a closet.",
      "link": "false",
      "alt_text": "Stacked front-loading washer and dryer in an in-unit laundry closet with a shelf at Chesapeake Pointe, offers Apartments for Rent in Chesapeake, VA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/5767906449162442/6767906449166313/955c94a0b10d31be1663ac48a9c292b8.jpg"
    },
    {
      "id": "custom_05b1545a-9589-417a-a323-f2304e41093d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-bd9c-70ea-91d7-157a2778b403.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, sink, toilet, and bathtub with shower.",
        "public_id": "019fcdf3-bd9c-70ea-91d7-157a2778b403",
        "storage_key": "property/6767906449166313/019fcdf3-bd9c-70ea-91d7-157a2778b403.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with a shower-tub combo, white vanity, and modern fixtures.",
      "link": "false",
      "alt_text": "Bathroom with tiled shower-tub combo, toilet, and white vanity at Chesapeake Pointe, offers Apartments for Rent in Chesapeake, VA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/5767906449162442/6767906449166313/0c68e924c4a36a6153d1701a789fb320.jpg"
    },
    {
      "id": "custom_6f638cc1-db8a-478c-9ac9-b49cb6a86271",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-be5b-722e-b81c-400d61df8013.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and chairs adjacent to a kitchen.",
        "public_id": "019fcdf3-be5b-722e-b81c-400d61df8013",
        "storage_key": "property/6767906449166313/019fcdf3-be5b-722e-b81c-400d61df8013.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen and dining space with white cabinetry, neutral tones, and a round wood dining table that seats six.",
      "link": "false",
      "alt_text": "Interior view of an apartment kitchen and dining area with white cabinets and a round wooden table at Chesapeake Pointe, offers Apartments for Rent in Chesapeake, VA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/5767906449162442/6767906449166313/e64b8b6c28b0d8aa9bcb4d386a44f0bd.jpg"
    },
    {
      "id": "custom_b759af81-6046-4e53-a3e1-610d6cc2f262",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-c8df-7786-8432-0cc1b12892bd.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops, stainless steel sink, dishwasher, and black appliances.",
        "public_id": "019fcdf3-c8df-7786-8432-0cc1b12892bd",
        "storage_key": "property/6767906449166313/019fcdf3-c8df-7786-8432-0cc1b12892bd.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Updated apartment with espresso cabinets and black appliances",
      "link": "false",
      "alt_text": "Kitchen with granite countertops, stainless steel sink, dishwasher, and black appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/Chesapeake+Pointe-POI-002.jpg"
    },
    {
      "id": "custom_35c2a942-a74f-4501-a63e-d31264a45b44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-c946-7104-af8b-ecbfc385327a.webp",
      "image_media": {
        "alt_text": "Living room with white sofa, accent chairs, coffee table, and artwork.",
        "public_id": "019fcdf3-c946-7104-af8b-ecbfc385327a",
        "storage_key": "property/6767906449166313/019fcdf3-c946-7104-af8b-ecbfc385327a.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable white sofa, accent chairs, a stylish coffee table, and tasteful wall art, creating a welcoming atmosphere.",
      "link": "false",
      "alt_text": "Living room in an apartment with white sofas and vertical blinds by large windows at Chesapeake Pointe, offers apartments in Chesapeake, VA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/5767906449162442/6767906449166313/d948c2e744283b47d7b56f38d9af716b.jpg"
    },
    {
      "id": "custom_3b7696dc-0d80-46cd-a5d9-543191c38586",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-c9c0-7324-b82f-eb9673bc49db.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, stove, dishwasher, and refrigerator.",
        "public_id": "019fcdf3-c9c0-7324-b82f-eb9673bc49db",
        "storage_key": "property/6767906449166313/019fcdf3-c9c0-7324-b82f-eb9673bc49db.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Cozy apartment kitchen with white cabinets, full-size appliances, and dark wood flooring.",
      "link": "false",
      "alt_text": "Compact apartment kitchen with white cabinets, stove, dishwasher, sink, and refrigerator at Chesapeake Pointe, offers apartments in Chesapeake, VA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/5767906449162442/6767906449166313/3b5186850907008cc3b0b5ead4fe682e.jpg"
    },
    {
      "id": "custom_49b0dc33-723b-4d04-98a1-233fe98d027d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-ca00-70ff-ba68-7f4adcdc9e61.webp",
      "image_media": {
        "alt_text": "Dining room with a table set for four, adjacent to a kitchen.",
        "public_id": "019fcdf3-ca00-70ff-ba68-7f4adcdc9e61",
        "storage_key": "property/6767906449166313/019fcdf3-ca00-70ff-ba68-7f4adcdc9e61.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright dining space in a modern apartment with a wood table, white chairs, and a visible kitchen.",
      "link": "false",
      "alt_text": "Dining area in an apartment with a wooden table, white chairs, and a kitchen in the background at Chesapeake Pointe, offers apartments in Chesapeake, VA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/5767906449162442/6767906449166313/8b3f1487d045e0fd400f985e7cfeeb5b.jpg"
    },
    {
      "id": "custom_dfd76d26-9944-4bf0-9f6d-aa2e157b0876",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-d401-76d9-9e2f-ff03ccc3a46f.webp",
      "image_media": {
        "alt_text": "Living room with TV, white bookshelf, leather chair, and sofa overlooking a balcony.",
        "public_id": "019fcdf3-d401-76d9-9e2f-ff03ccc3a46f",
        "storage_key": "property/6767906449166313/019fcdf3-d401-76d9-9e2f-ff03ccc3a46f.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Neutral-toned living room in a model apartment with contemporary furniture and a balcony door.",
      "link": "false",
      "alt_text": "Living room in an apartment with white sofas, a TV stand, a bookshelf, and sliding glass door with vertical blinds at Chesapeake Pointe, offers apartments in Chesapeake, VA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/5767906449162442/6767906449166313/5f6af508216067298120d0a5203c9b7d.jpg"
    },
    {
      "id": "custom_bcf6f81e-2a34-4b75-93f7-fa0a8dbf1250",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-d485-767c-b7cc-b7d8cd6ca0f0.webp",
      "image_media": {
        "alt_text": "Dining area with a round table, chairs, and a stacked washer/dryer unit.",
        "public_id": "019fcdf3-d485-767c-b7cc-b7d8cd6ca0f0",
        "storage_key": "property/6767906449166313/019fcdf3-d485-767c-b7cc-b7d8cd6ca0f0.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Cozy dining area in a modern apartment with a round table, white chairs, and an in-unit washer/dryer near the kitchen.",
      "link": "false",
      "alt_text": "Dining nook with round wooden table, four white chairs, and a washer/dryer in the adjacent kitchen at Chesapeake Pointe, offers apartments in Chesapeake, VA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/5767906449162442/6767906449166313/b95ca12a97922abe96d27ee5497cf419.jpg"
    },
    {
      "id": "custom_517bc9d5-00ab-4772-a941-d00aec19f096",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-d5bd-70f8-aa20-29211d3c679e.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, coffee table, and TV.",
        "public_id": "019fcdf3-d5bd-70f8-aa20-29211d3c679e",
        "storage_key": "property/6767906449166313/019fcdf3-d5bd-70f8-aa20-29211d3c679e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Modern apartment living room with neutral decor, seating area, a TV, and a large window with vertical blinds.",
      "link": "false",
      "alt_text": "Living room in an apartment with beige sofas, a wooden coffee table, TV, and a large window with vertical blinds at Chesapeake Pointe, offers apartments in Chesapeake, VA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/5767906449162442/6767906449166313/1b427646f53e8925e8424ff9463a5b1e.jpg"
    },
    {
      "id": "custom_2725d80d-177c-4af9-bd16-1e392abe3144",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-d74e-71bd-a4b7-160e96c6d3d7.webp",
      "image_media": {
        "alt_text": "A well-lit bedroom with a tufted headboard, plush bedding, and decorative pillows.",
        "public_id": "019fcdf3-d74e-71bd-a4b7-160e96c6d3d7",
        "storage_key": "property/6767906449166313/019fcdf3-d74e-71bd-a4b7-160e96c6d3d7.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a cozy bed and elegant decor.",
      "link": "false",
      "alt_text": "Bedroom with tufted headboard bed, white bedding, wooden dresser, plant, and window with sheer curtains at Chesapeake Pointe, offers apartments in Chesapeake, VA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/5767906449162442/6767906449166313/88575991335ad8d7bafe8eed4def25b1.jpg"
    },
    {
      "id": "custom_a2921454-0e8e-4cca-870a-26c3921463a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-dfa8-7266-8fc0-e05effcd80fa.webp",
      "image_media": {
        "alt_text": "Modern living room with a sectional sofa, coffee table, entertainment center, and a glimpse of a kitchen island with bar stools.",
        "public_id": "019fcdf3-dfa8-7266-8fc0-e05effcd80fa",
        "storage_key": "property/6767906449166313/019fcdf3-dfa8-7266-8fc0-e05effcd80fa.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Cozy apartment living area featuring a white sectional, TV, bar-height counter with stools, and decorative shelving.",
      "link": "false",
      "alt_text": "Basement-style apartment living room with white sectional sofa, TV, bar counter with stools, and open shelving at Chesapeake Pointe, offers Chesapeake, VA apartments for rent.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/5767906449162442/6767906449166313/9cf7e10a22e4ca28c7045bc236062c8c.jpg"
    },
    {
      "id": "custom_3efb47b7-aa94-4e26-87f7-989ea67c2fc4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-e0c6-774d-b6b2-75ebaf6af36f.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, mirrored wardrobe, and a full-length mirror.",
        "public_id": "019fcdf3-e0c6-774d-b6b2-75ebaf6af36f",
        "storage_key": "property/6767906449166313/019fcdf3-e0c6-774d-b6b2-75ebaf6af36f.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Cozy apartment bedroom with a tufted headboard and neutral bedding, a bright window, and a white-framed dresser mirror.",
      "link": "false",
      "alt_text": "Bedroom in an apartment with a queen bed, window with sheer curtains, and a white dresser with a mirror at Chesapeake Pointe, offers apartments in Chesapeake, VA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/5767906449162442/6767906449166313/e07cd2197aca0da29561b32c35009c08.jpg"
    },
    {
      "id": "custom_d1a6e7b3-714d-4cf4-94fc-cffa4fd54c95",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-e192-702d-ba0c-21c0b0c687ff.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a king-size bed, tufted headboard, and a large closet.",
        "public_id": "019fcdf3-e192-702d-ba0c-21c0b0c687ff",
        "storage_key": "property/6767906449166313/019fcdf3-e192-702d-ba0c-21c0b0c687ff.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Cozy master bedroom with tufted headboard, wood dresser, and open closet space in a modern apartment.",
      "link": "false",
      "alt_text": "Bedroom with a tufted headboard, dresser, bench, and open closet doors at Chesapeake Pointe, offers Chesapeake, VA apartments for rent.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/5767906449162442/6767906449166313/95756891a0f95cce17e4150051eee05b.jpg"
    },
    {
      "id": "custom_de827096-f7af-464a-bda1-37254b4bc0cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-e38d-7019-9e4e-9cd4143d490e.webp",
      "image_media": {
        "alt_text": "Balcony overlooking a parking lot and apartment buildings",
        "public_id": "019fcdf3-e38d-7019-9e4e-9cd4143d490e",
        "storage_key": "property/6767906449166313/019fcdf3-e38d-7019-9e4e-9cd4143d490e.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Enjoy your morning coffee or evening drink on the private balcony, overlooking the community grounds and ample parking.",
      "link": "false",
      "alt_text": "Balcony with white cushioned chairs and blue pillows overlooking a parking lot at Chesapeake Pointe, offers apartments in Chesapeake, VA.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/5767906449162442/6767906449166313/e7cc18b9c3396764343b1d15388c0265.jpg"
    },
    {
      "id": "custom_41e652ae-0d91-40bd-abc1-cacaa1803cc8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-ecd4-7216-9880-88a522a00c41.webp",
      "image_media": {
        "alt_text": "Living room with sofa, armchair, coffee table, and dining area visible.",
        "public_id": "019fcdf3-ecd4-7216-9880-88a522a00c41",
        "storage_key": "property/6767906449166313/019fcdf3-ecd4-7216-9880-88a522a00c41.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious living area with contemporary furnishings, an open dining nook, and entertainment shelving.",
      "link": "false",
      "alt_text": "Living room in an apartment with a beige sofa, chairs, and a wooden coffee table at Chesapeake Pointe, offers Chesapeake, VA apartments for rent.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/5767906449162442/6767906449166313/93f4130e6e4303f607b747ef2301ac25.jpg"
    },
    {
      "id": "custom_aa874a5f-46c7-4af4-a5be-2150cfb1793a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-ed44-7223-8083-41a7e06c582f.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, next to a children's playground.",
        "public_id": "019fcdf3-ed44-7223-8083-41a7e06c582f",
        "storage_key": "property/6767906449166313/019fcdf3-ed44-7223-8083-41a7e06c582f.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling pool, surrounded by comfortable lounge seating and umbrellas. A fun playground is also available for the little ones.",
      "link": "false",
      "alt_text": "Aerial view of a fenced apartment pool area with lounge chairs and orange umbrellas; a playground is nearby at Chesapeake Pointe, offers pet-friendly apartments in Chesapeake, VA",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/7222a5f736321437628c093f1d7a0e84-7d62a372.jpg"
    },
    {
      "id": "custom_23f16131-f52d-4a09-a115-f9683dbdaa4b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-f1c2-72bc-a432-9d1e6aed2eca.webp",
      "image_media": {
        "alt_text": "Colorful playground with slides and climbing structures in a grassy area with trees.",
        "public_id": "019fcdf3-f1c2-72bc-a432-9d1e6aed2eca",
        "storage_key": "property/6767906449166313/019fcdf3-f1c2-72bc-a432-9d1e6aed2eca.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our vibrant playground, perfect for children to explore and play.",
      "link": "false",
      "alt_text": "Colorful outdoor playground with slides and climbing structures in a shaded area at Chesapeake Pointe, offers pet-friendly apartments in Chesapeake, VA",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/5767906449162442/6767906449166313/91ea8994703b2786dbe93d03f0a896b7.jpg"
    },
    {
      "id": "custom_78f91e2b-b27c-482e-b2f2-e9f869733f4e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-f2ae-7467-88eb-77863f23c014.webp",
      "image_media": {
        "alt_text": "Swimming pool and playground area with lounge chairs and tables.",
        "public_id": "019fcdf3-f2ae-7467-88eb-77863f23c014",
        "storage_key": "property/6767906449166313/019fcdf3-f2ae-7467-88eb-77863f23c014.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool or let the kids play at the on-site playground. Perfect for relaxation and family fun.",
      "link": "false",
      "alt_text": "Outdoor apartment pool area with lounge chairs and orange umbrellas; a playground visible beyond at Chesapeake Pointe, offers pet-friendly apartments in Chesapeake, VA",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/5767906449162442/6767906449166313/016f01519db1451affe78ab41d4043d2.jpg"
    },
    {
      "id": "custom_8c82e64f-ce8b-44ca-a1a0-6e0fef6a0aa3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-fb36-72ca-99fe-075773264490.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structures",
        "public_id": "019fcdf3-fb36-72ca-99fe-075773264490",
        "storage_key": "property/6767906449166313/019fcdf3-fb36-72ca-99fe-075773264490.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Outdoor community playground with slides and climbing features near residential buildings.",
      "link": "false",
      "alt_text": "Colorful outdoor playground with slides and climbing structure beside apartment buildings at Chesapeake Pointe, offers pet-friendly apartments in Chesapeake, VA",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/5767906449162442/6767906449166313/45a0a77ec014d3c17597ddd41f930f3e.jpg"
    },
    {
      "id": "custom_5ce2f7bf-ebdb-4790-8f8f-3bd99c62c77a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-fba4-751c-ab2b-f88a5dfeca12.webp",
      "image_media": {
        "alt_text": "Exterior of an apartment building with balconies and manicured landscaping.",
        "public_id": "019fcdf3-fba4-751c-ab2b-f88a5dfeca12",
        "storage_key": "property/6767906449166313/019fcdf3-fba4-751c-ab2b-f88a5dfeca12.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Exterior view of the apartment building featuring balconies, well-maintained green spaces, and a welcoming walkway.",
      "link": "false",
      "alt_text": "Exterior view of a beige apartment building with balconies, hedges, and a walkway at Chesapeake Pointe, offers pet-friendly apartments in Chesapeake, VA",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/5767906449162442/6767906449166313/00042e73af20946f4540f8b3dfe57e61.jpg"
    },
    {
      "id": "custom_b9d1d713-c503-4ce3-a434-c0f4c2a311ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf3-ff12-73dd-bf83-a6d53b0d929a.webp",
      "image_media": {
        "alt_text": "Exterior view of brick townhouses with black shutters and arched doorways.",
        "public_id": "019fcdf3-ff12-73dd-bf83-a6d53b0d929a",
        "storage_key": "property/6767906449166313/019fcdf3-ff12-73dd-bf83-a6d53b0d929a.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Exterior shot of a brick townhouse-style multifamily building with multiple front doors and dormer windows.",
      "link": "false",
      "alt_text": "Exterior view of a brick multifamily building with individual entrances and black shutters at Chesapeake Pointe, offers pet-friendly apartments in Chesapeake, VA",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5834c124/dms3rep/multi/5767906449162442/6767906449166313/596fa6489d93a569b8404f82b64a803e.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_401779bb-fd50-4115-8099-aaeb2f04f9bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Baker's Crust Artisan Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "1244 Greenbrier Pkwy #510, Chesapeake, VA 23320, USA",
      "poi_short_description": "Relaxed New American chain serving breakfast, sandwiches, wood-fired pizzas & creative entrees.",
      "poi_long_description": "Relaxed New American chain serving breakfast, sandwiches, wood-fired pizzas & creative entrees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-1306-713e-9de7-39d233e489b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-1306-713e-9de7-39d233e489b8",
        "storage_key": "property/6767906449166313/019fcdf4-1306-713e-9de7-39d233e489b8.webp",
        "width": 750,
        "height": 439
      },
      "poi_business_url": "https://www.bakerscrust.com/locations/chesapeake-greenbrier?utm_source=Google_GBP&utm_medium=Profile_Link&utm_campaign=local_seo&utm_term=greenbrier",
      "poi_directions_map_url": "https://maps.google.com/?cid=857802157156007291&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bakers-crust-artisan-kitchen",
      "poi_latitude": "36.7705288",
      "poi_longitude": "-76.2301519",
      "poi_miles_from_property": "17.6 mi",
      "poi_walking_minutes": "6 hours 33 mins",
      "poi_biking_minutes": "1 hour 31 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 757-547-2787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1325-7328-9b9a-a683c0313b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1325-7328-9b9a-a683c0313b6d",
        "storage_key": "property/6767906449166313/019d0266-1325-7328-9b9a-a683c0313b6d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs9H10vS8uokRe_3YYISG5ws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dc5c8503-d762-4264-bdac-d0d709f7b614",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Winston's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1412 Greenbrier Pkwy #133, Chesapeake, VA 23320, USA",
      "poi_short_description": "Welcoming, casual hangout featuring classic & creative American eats, live music & cocktails.",
      "poi_long_description": "Welcoming, casual hangout featuring classic & creative American eats, live music & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-12a5-720b-9b55-dbce5e401f74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-12a5-720b-9b55-dbce5e401f74",
        "storage_key": "property/6767906449166313/019fcdf4-12a5-720b-9b55-dbce5e401f74.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://winstonscafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16398744671137619387&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "winstons-cafe",
      "poi_latitude": "36.7754322",
      "poi_longitude": "-76.23087029999999",
      "poi_miles_from_property": "17.9 mi",
      "poi_walking_minutes": "6 hours 40 mins",
      "poi_biking_minutes": "1 hour 29 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 757-420-1751",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1325-7328-9b9a-a683c0313b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1325-7328-9b9a-a683c0313b6d",
        "storage_key": "property/6767906449166313/019d0266-1325-7328-9b9a-a683c0313b6d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD7nzvvG8uokRu9185WQLlOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2506ffc1-6080-423c-b57f-03825d4d2adf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Smokey Bones Chesapeake",
      "poi_type": "Restaurants",
      "poi_address": "1405 Greenbrier Pkwy, Chesapeake, VA 23320, USA",
      "poi_short_description": "Smokehouse & barbecue dishes fill out the menu of this easygoing bar & grill chain.",
      "poi_long_description": "Smokehouse & barbecue dishes fill out the menu of this easygoing bar & grill chain.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-12cf-75fe-9ce2-1c9018e42dca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-12cf-75fe-9ce2-1c9018e42dca",
        "storage_key": "property/6767906449166313/019fcdf4-12cf-75fe-9ce2-1c9018e42dca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.smokeybones.com/va/chesapeake/1405-greenbrier-parkway/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5271758429180770284&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smokey-bones-chesapeake",
      "poi_latitude": "36.776159",
      "poi_longitude": "-76.2292044",
      "poi_miles_from_property": "19.0 mi",
      "poi_walking_minutes": "7 hours 4 mins",
      "poi_biking_minutes": "1 hour 29 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 757-361-6843",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1325-7328-9b9a-a683c0313b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1325-7328-9b9a-a683c0313b6d",
        "storage_key": "property/6767906449166313/019d0266-1325-7328-9b9a-a683c0313b6d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmUJmova8uokR7Lf9QFwMKUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_48178c73-d6b5-4171-a206-35d4c38077c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Black Pelican Seafood Co. Greenbrier",
      "poi_type": "Restaurants",
      "poi_address": "1625 Ring Rd, Chesapeake, VA 23320, USA",
      "poi_short_description": "Contemporary, nautical-themed seafood specialist serving regional fare & wood-fired pizzas.",
      "poi_long_description": "Contemporary, nautical-themed seafood specialist serving regional fare & wood-fired pizzas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-1340-752e-82d7-9ab91eb31c7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-1340-752e-82d7-9ab91eb31c7c",
        "storage_key": "property/6767906449166313/019fcdf4-1340-752e-82d7-9ab91eb31c7c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.blackpelicangreenbrier.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3512048395866798276&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-pelican-seafood-co-greenbrier",
      "poi_latitude": "36.776894",
      "poi_longitude": "-76.228319",
      "poi_miles_from_property": "18.9 mi",
      "poi_walking_minutes": "7 hours 3 mins",
      "poi_biking_minutes": "1 hour 29 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 757-424-3171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1325-7328-9b9a-a683c0313b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1325-7328-9b9a-a683c0313b6d",
        "storage_key": "property/6767906449166313/019d0266-1325-7328-9b9a-a683c0313b6d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaatC9vm8uokRxPiejWhNvTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_47e90177-87e7-4120-a5ac-bf7a90ad8847",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "4117 Chesapeake Square Blvd, Chesapeake, VA 23321, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-197d-722a-ae4e-876f45bbe471.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-197d-722a-ae4e-876f45bbe471",
        "storage_key": "property/6767906449166313/019fcdf4-197d-722a-ae4e-876f45bbe471.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.olivegarden.com/locations/va/chesapeake/chesapeake-square-mall/1297?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:chesapeake-va-1297_pl:locurl_rd:1224",
      "poi_directions_map_url": "https://maps.google.com/?cid=13659309955861829899&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "36.824676",
      "poi_longitude": "-76.41027799999999",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 757-465-2139",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1325-7328-9b9a-a683c0313b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1325-7328-9b9a-a683c0313b6d",
        "storage_key": "property/6767906449166313/019d0266-1325-7328-9b9a-a683c0313b6d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwa3NOk2guokRC9kZ5Aiej70",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_82c45736-6e07-4b99-bd14-a32fd90641d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Red Robin Gourmet Burgers and Brews",
      "poi_type": "Restaurants",
      "poi_address": "2524 Chesapeake Square Ring Rd, Chesapeake, VA 23321, USA",
      "poi_short_description": "Chain for gourmet burgers & other American comfort fare.",
      "poi_long_description": "Chain for gourmet burgers & other American comfort fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-1924-70eb-9bb0-a583eea5b7aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-1924-70eb-9bb0-a583eea5b7aa",
        "storage_key": "property/6767906449166313/019fcdf4-1924-70eb-9bb0-a583eea5b7aa.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.redrobin.com/locations/va/chesapeake/chesapeake-428?store_id=428&store_type=corporate&utm_campaign=local-business-listing&utm_content=website-link&utm_medium=organic-seach&utm_source=google-business-profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=1957359441310363062&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-robin-gourmet-burgers-and-brews",
      "poi_latitude": "36.8243289",
      "poi_longitude": "-76.41839230000001",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 757-488-8477",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1325-7328-9b9a-a683c0313b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1325-7328-9b9a-a683c0313b6d",
        "storage_key": "property/6767906449166313/019d0266-1325-7328-9b9a-a683c0313b6d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzz0m80uguokRtq0PlQrwKRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_308901b5-7fb4-479a-a5a8-fde4dcc7b3bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "1546 Sam's Cir, Chesapeake, VA 23320, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-1a02-7120-a50c-fd1dc496802b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-1a02-7120-a50c-fd1dc496802b",
        "storage_key": "property/6767906449166313/019fcdf4-1a02-7120-a50c-fd1dc496802b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/virginia/chesapeake?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=15482508708490794234&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.77447009999999",
      "poi_longitude": "-76.2512977",
      "poi_miles_from_property": "16.5 mi",
      "poi_walking_minutes": "6 hours 8 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 757-382-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1325-7328-9b9a-a683c0313b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1325-7328-9b9a-a683c0313b6d",
        "storage_key": "property/6767906449166313/019d0266-1325-7328-9b9a-a683c0313b6d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqd5Ei8C8uokR-lR8-aPr3NY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_21346900-91d8-4a5b-a626-835f1ae8e96d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Pop's Diner Co.",
      "poi_type": "Restaurants",
      "poi_address": "1432 Greenbrier Pkwy, Chesapeake, VA 23320, USA",
      "poi_short_description": "Local chain serving breakfast, sandwiches, classic American dishes & cocktails in a modest space.",
      "poi_long_description": "Local chain serving breakfast, sandwiches, classic American dishes & cocktails in a modest space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-1abb-7410-abad-f7e974ae09a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-1abb-7410-abad-f7e974ae09a1",
        "storage_key": "property/6767906449166313/019fcdf4-1abb-7410-abad-f7e974ae09a1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://popsdinerco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4114427487024155193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pops-diner-co",
      "poi_latitude": "36.7778657",
      "poi_longitude": "-76.2314555",
      "poi_miles_from_property": "18.2 mi",
      "poi_walking_minutes": "6 hours 46 mins",
      "poi_biking_minutes": "1 hour 29 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 757-502-8220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1325-7328-9b9a-a683c0313b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1325-7328-9b9a-a683c0313b6d",
        "storage_key": "property/6767906449166313/019d0266-1325-7328-9b9a-a683c0313b6d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXX7MJPG8uokROYotEgBiGTk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_329b6820-94f4-42b8-9d0d-6486b2a1813a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Bubba's 33",
      "poi_type": "Restaurants",
      "poi_address": "1725 Debaun Ave, Chesapeake, VA 23320, USA",
      "poi_short_description": "Burgers, pizza & beer served alongside many large-screen TVs showing sports & music videos.",
      "poi_long_description": "Burgers, pizza & beer served alongside many large-screen TVs showing sports & music videos.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-1f4b-714d-84e9-a7d63560b8bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-1f4b-714d-84e9-a7d63560b8bd",
        "storage_key": "property/6767906449166313/019fcdf4-1f4b-714d-84e9-a7d63560b8bd.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.bubbas33.com/locations/virginia/chesapeake?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=12574862648424376323&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bubbas-33",
      "poi_latitude": "36.7783326",
      "poi_longitude": "-76.2580443",
      "poi_miles_from_property": "15.1 mi",
      "poi_walking_minutes": "5 hours 36 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 757-447-4242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1325-7328-9b9a-a683c0313b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1325-7328-9b9a-a683c0313b6d",
        "storage_key": "property/6767906449166313/019d0266-1325-7328-9b9a-a683c0313b6d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvctpt3y9uokRA6ipSvTigq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dc911004-96a7-498c-ad43-fa05aed10a29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Cutlass Grille",
      "poi_type": "Restaurants",
      "poi_address": "725 Eden Way N #700, Chesapeake, VA 23320, USA",
      "poi_short_description": "Unpretentious restaurant offering traditional Jamaican fare & beverages, plus a kids' menu.",
      "poi_long_description": "Unpretentious restaurant offering traditional Jamaican fare & beverages, plus a kids' menu.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-203b-7580-9b86-f23535adb013.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-203b-7580-9b86-f23535adb013",
        "storage_key": "property/6767906449166313/019fcdf4-203b-7580-9b86-f23535adb013.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cutlassgrille.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17155600687266664109&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cutlass-grille",
      "poi_latitude": "36.7721843",
      "poi_longitude": "-76.2359051",
      "poi_miles_from_property": "17.5 mi",
      "poi_walking_minutes": "6 hours 32 mins",
      "poi_biking_minutes": "1 hour 33 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 757-382-0015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1325-7328-9b9a-a683c0313b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1325-7328-9b9a-a683c0313b6d",
        "storage_key": "property/6767906449166313/019d0266-1325-7328-9b9a-a683c0313b6d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJZJlkX-8uokRrQ76SO7vFO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e68377f3-1cd1-4d09-9823-efa01c5b892e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Towne Point Pub & Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "3558 Towne Point Rd, Portsmouth, VA 23703, USA",
      "poi_short_description": "Relaxed pub offering a variety of beers, happy-hour specials, and bar bites, plus karaoke, and a smoking room.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-205d-743c-9f97-4d8a95c2cd5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-205d-743c-9f97-4d8a95c2cd5d",
        "storage_key": "property/6767906449166313/019fcdf4-205d-743c-9f97-4d8a95c2cd5d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9668091488142777391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "towne-point-pub--restaurant",
      "poi_latitude": "36.8670656",
      "poi_longitude": "-76.39967",
      "poi_miles_from_property": "262 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 757-673-0195",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019f950f-9f99-7288-9f63-b83cc5f3c7bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f950f-9f99-7288-9f63-b83cc5f3c7bf",
        "storage_key": "property/6767906449166313/019f950f-9f99-7288-9f63-b83cc5f3c7bf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfcaLtnGfuokRL1y6Fvz1K4Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5709c2cc-dd61-4723-a33c-bfd073f480e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "S & J Seafood",
      "poi_type": "Restaurants",
      "poi_address": "3546 Towne Point Rd, Portsmouth, VA 23703, USA",
      "poi_short_description": "Casual restaurant specializing in seafood for lunch and dinner.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-215a-7389-9825-91e9cc63c086.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-215a-7389-9825-91e9cc63c086",
        "storage_key": "property/6767906449166313/019fcdf4-215a-7389-9825-91e9cc63c086.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6699694765588393066&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "s--j-seafood",
      "poi_latitude": "36.8669328",
      "poi_longitude": "-76.39971609999999",
      "poi_miles_from_property": "220 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 757-484-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1325-7328-9b9a-a683c0313b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1325-7328-9b9a-a683c0313b6d",
        "storage_key": "property/6767906449166313/019d0266-1325-7328-9b9a-a683c0313b6d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVu2tXGfuokRaqxwjuQY-lw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cbd716b5-9924-47bc-9ace-9ed27c6e16a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "The Butcher's Son",
      "poi_type": "Restaurants",
      "poi_address": "500 S Battlefield Blvd, Chesapeake, VA 23322, USA",
      "poi_short_description": "Dark, stylish chophouse with select, organic steak & seafood meals, craft beers & Sunday brunch.",
      "poi_long_description": "Dark, stylish chophouse with select, organic steak & seafood meals, craft beers & Sunday brunch.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-2563-7607-be4a-c57e1ab59934.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-2563-7607-be4a-c57e1ab59934",
        "storage_key": "property/6767906449166313/019fcdf4-2563-7607-be4a-c57e1ab59934.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://www.butcherson.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17235417407705963706&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-butchers-son",
      "poi_latitude": "36.7065272",
      "poi_longitude": "-76.2369391",
      "poi_miles_from_property": "19.7 mi",
      "poi_walking_minutes": "7 hours 20 mins",
      "poi_biking_minutes": "1 hour 45 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 757-410-5466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1325-7328-9b9a-a683c0313b6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1325-7328-9b9a-a683c0313b6d",
        "storage_key": "property/6767906449166313/019d0266-1325-7328-9b9a-a683c0313b6d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJU6RTv-K6uokRutzlrdCAMO8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3d312966-0c8c-4fc5-8112-563e23969f5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Starbucks",
      "poi_type": "Restaurants",
      "poi_address": "2400 Chesapeake Square Ring Rd, Chesapeake, VA 23321, USA",
      "poi_short_description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
      "poi_long_description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-269c-74a7-8c7c-cebbcd2037bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-269c-74a7-8c7c-cebbcd2037bb",
        "storage_key": "property/6767906449166313/019fcdf4-269c-74a7-8c7c-cebbcd2037bb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/1010310/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11640550845534413293&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks",
      "poi_latitude": "36.82739",
      "poi_longitude": "-76.41051",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 757-488-2123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1310-722e-847a-92131f57d394.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1310-722e-847a-92131f57d394",
        "storage_key": "property/6767906449166313/019d0266-1310-722e-847a-92131f57d394.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJqQvvyUuguokR7aHz2VGLi6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7da3f1c1-1561-48ab-91de-b748fc52b0c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Lili Delites Corner Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "3525 Towne Point Rd Unit #9, Portsmouth, VA 23703, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-2796-734d-a97b-ed3196b6766b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-2796-734d-a97b-ed3196b6766b",
        "storage_key": "property/6767906449166313/019fcdf4-2796-734d-a97b-ed3196b6766b.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://lilidelites.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12064079154336814873&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lili-delites-corner-mart",
      "poi_latitude": "36.8673118",
      "poi_longitude": "-76.4010306",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 757-484-4927",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1846-7759-82b9-be5ef61c557b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1846-7759-82b9-be5ef61c557b",
        "storage_key": "property/6767906449166313/019d0266-1846-7759-82b9-be5ef61c557b.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJXxG0Oa-fuokRGddwmBI4bKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_269f6254-507d-4359-b7a8-1aebc313507b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Peters Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "3100 Churchland Blvd, Chesapeake, VA 23321, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-27fc-747e-8d32-01d532eb761d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-27fc-747e-8d32-01d532eb761d",
        "storage_key": "property/6767906449166313/019fcdf4-27fc-747e-8d32-01d532eb761d.webp",
        "width": 640,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14030215658193330684&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peters-market",
      "poi_latitude": "36.8660524",
      "poi_longitude": "-76.40037459999999",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 757-484-0170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1846-7759-82b9-be5ef61c557b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1846-7759-82b9-be5ef61c557b",
        "storage_key": "property/6767906449166313/019d0266-1846-7759-82b9-be5ef61c557b.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJJTnHqcafuokR_KG8TM5WtcI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4bfce553-b4a7-434b-8779-2be657d54920",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Royal Farms",
      "poi_type": "Shopping & Retail",
      "poi_address": "3026 Churchland Blvd, Chesapeake, VA 23321, USA",
      "poi_short_description": "Gas-station & convenience-store chain serving breakfast sandwiches, fried chicken & deli items.",
      "poi_long_description": "Gas-station & convenience-store chain serving breakfast sandwiches, fried chicken & deli items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-2b9f-73fc-b20e-9208a5645fa2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-2b9f-73fc-b20e-9208a5645fa2",
        "storage_key": "property/6767906449166313/019fcdf4-2b9f-73fc-b20e-9208a5645fa2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.royalfarms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15323869295096697698&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "royal-farms",
      "poi_latitude": "36.8657629",
      "poi_longitude": "-76.3989914",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 757-998-8399",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1846-7759-82b9-be5ef61c557b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1846-7759-82b9-be5ef61c557b",
        "storage_key": "property/6767906449166313/019d0266-1846-7759-82b9-be5ef61c557b.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJt-58JHCfuokRYhPBPu9RqdQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fcc7ac20-820d-4dd9-86a4-0c00a480d623",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "5734 Churchland Blvd, Portsmouth, VA 23703, USA",
      "poi_short_description": "Chain grocery store known for its fresh produce and meats.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-2d2d-764a-a49c-0d13b2326b39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-2d2d-764a-a49c-0d13b2326b39",
        "storage_key": "property/6767906449166313/019fcdf4-2d2d-764a-a49c-0d13b2326b39.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.foodlion.com/va/portsmouth/5734-churchland-blvd.?y_source=1_NTA0NjQyOS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6900231251543632562&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "36.8624633",
      "poi_longitude": "-76.3904259",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 757-483-0480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-139e-72d1-817a-b95df0b32acf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-139e-72d1-817a-b95df0b32acf",
        "storage_key": "property/6767906449166313/019d0266-139e-72d1-817a-b95df0b32acf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdfODemafuokRsqpOqMOLwl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a79766ce-ba7b-46f5-9510-ae0a8c479a61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Harris Teeter",
      "poi_type": "Shopping & Retail",
      "poi_address": "3249 Tyre Neck Rd, Portsmouth, VA 23703, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty aids.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty aids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-2eac-753b-b66f-05c1a806cd56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-2eac-753b-b66f-05c1a806cd56",
        "storage_key": "property/6767906449166313/019fcdf4-2eac-753b-b66f-05c1a806cd56.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.harristeeter.com/stores/grocery/va/portsmouth/churchland-marketplace/097/00315?cid=loc_09700315_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=11253723566301691755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harris-teeter",
      "poi_latitude": "36.8623003",
      "poi_longitude": "-76.3944817",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 757-483-9235",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-139e-72d1-817a-b95df0b32acf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-139e-72d1-817a-b95df0b32acf",
        "storage_key": "property/6767906449166313/019d0266-139e-72d1-817a-b95df0b32acf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJde3dvmWfuokRa7_acfVBLZw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f0e2715c-e730-4301-9611-ae038e9df4c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "5811 High St W, Portsmouth, VA 23703, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-2eb8-7291-8de2-68540fd7ee58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-2eb8-7291-8de2-68540fd7ee58",
        "storage_key": "property/6767906449166313/019fcdf4-2eb8-7291-8de2-68540fd7ee58.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://stores.aldi.us/va/portsmouth/5811-west-high-street?utm_source=google&utm_medium=local&utm_campaign=brand&utm_content=storepage_webclick",
      "poi_directions_map_url": "https://maps.google.com/?cid=15552029845974719664&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "36.8599901",
      "poi_longitude": "-76.39393419999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-139e-72d1-817a-b95df0b32acf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-139e-72d1-817a-b95df0b32acf",
        "storage_key": "property/6767906449166313/019d0266-139e-72d1-817a-b95df0b32acf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG9KRN2SfuokRsJyYKb_o09c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6e048fea-7e58-4304-8f14-6461d83e27c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "5917 High St W, Portsmouth, VA 23703, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-312d-777a-9c6c-3e728d71523b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-312d-777a-9c6c-3e728d71523b",
        "storage_key": "property/6767906449166313/019fcdf4-312d-777a-9c6c-3e728d71523b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-5917+high+st+w-portsmouth-va-23703/id=7116",
      "poi_directions_map_url": "https://maps.google.com/?cid=2104104186773428611&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "36.8602615",
      "poi_longitude": "-76.39694089999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 757-686-5929",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1847-7618-a1ea-a342213bb793",
        "storage_key": "property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb3_9gYOfuokRg9kKH5xHMx0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_612bb6d5-b6f4-4d5d-8fd4-2d58cff0d3ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "4200 Portsmouth Blvd STE 600, Chesapeake, VA 23321, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-3418-721b-8cdf-38fab7978d0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-3418-721b-8cdf-38fab7978d0c",
        "storage_key": "property/6767906449166313/019fcdf4-3418-721b-8cdf-38fab7978d0c.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/chesapeake-va-pharmacies/4200-portsmouth-blvd-chesapeake-va-23321/storeid=16758?WT.mc_id=LS_GOOGLE_RX_16758",
      "poi_directions_map_url": "https://maps.google.com/?cid=5653866802518777876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "36.8260222",
      "poi_longitude": "-76.4154513",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 757-465-8618",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1e04-74fb-ac5e-a6513c769257.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1e04-74fb-ac5e-a6513c769257",
        "storage_key": "property/6767906449166313/019d0266-1e04-74fb-ac5e-a6513c769257.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_Xys2U2guokRFGCBw-aRdk4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a7543b8e-8e84-4e28-9e2d-a65b27bd5c99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Speedway",
      "poi_type": "Shopping & Retail",
      "poi_address": "3260 Western Branch Blvd, Chesapeake, VA 23321, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-3536-7065-80f6-1a58fd65cbe1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-3536-7065-80f6-1a58fd65cbe1",
        "storage_key": "property/6767906449166313/019fcdf4-3536-7065-80f6-1a58fd65cbe1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.speedway.com/locations/VA/Chesapeake/3260-Western-Branch-Blvd.?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=8576156126076033494&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "speedway",
      "poi_latitude": "36.8653832",
      "poi_longitude": "-76.4091863",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 757-484-3642",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-8ab8-727f-97a4-6ccb75637d17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fcdf4-8ab8-727f-97a4-6ccb75637d17",
        "storage_key": "property/6767906449166313/019fcdf4-8ab8-727f-97a4-6ccb75637d17.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-WWk93efuokR1lkN6Y6gBHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_856def71-7a83-4b2b-b23e-f4df8fe7af91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "5744 Churchland Blvd Churchland Shp Ctr, Portsmouth, VA 23703, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-3411-767f-9156-d8e483a378bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-3411-767f-9156-d8e483a378bf",
        "storage_key": "property/6767906449166313/019fcdf4-3411-767f-9156-d8e483a378bf.webp",
        "width": 864,
        "height": 864
      },
      "poi_business_url": "https://locations.familydollar.com/va/portsmouth/5744-churchland-blvd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=3833977299068873929&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "36.8629003",
      "poi_longitude": "-76.3911012",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 757-335-6616",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1325-7328-9b9a-a83d4f4fdbd9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1325-7328-9b9a-a83d4f4fdbd9",
        "storage_key": "property/6767906449166313/019d0266-1325-7328-9b9a-a83d4f4fdbd9.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbyzbcGafuokRyWzpSwoGNTU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_055cb4c1-4b56-49ea-8553-0248e3e4aca7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Western Branch Primary School",
      "poi_type": "Education",
      "poi_address": "4122 Terry Dr, Chesapeake, VA 23321, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4535141088878593560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "western-branch-primary-school",
      "poi_latitude": "36.8463487",
      "poi_longitude": "-76.40301579999999",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 757-638-7951",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1846-7759-82b9-c047b4b6279b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1846-7759-82b9-c047b4b6279b",
        "storage_key": "property/6767906449166313/019d0266-1846-7759-82b9-c047b4b6279b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW55ho9GhuokRGAbjyMoO8D4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b72b29ba-aaff-4c4f-a75c-0fad1a4aad7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Western Branch Intermediate",
      "poi_type": "Education",
      "poi_address": "4013 Terry Dr, Chesapeake, VA 23321, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-36e9-7159-ace4-dcd9ffafee7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-36e9-7159-ace4-dcd9ffafee7c",
        "storage_key": "property/6767906449166313/019fcdf4-36e9-7159-ace4-dcd9ffafee7c.webp",
        "width": 1137,
        "height": 640
      },
      "poi_business_url": "https://www.cpschools.com/o/wbi",
      "poi_directions_map_url": "https://maps.google.com/?cid=5276081774852957196&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "western-branch-intermediate",
      "poi_latitude": "36.8458681",
      "poi_longitude": "-76.3999608",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 757-638-7941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1846-7759-82b9-c047b4b6279b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1846-7759-82b9-c047b4b6279b",
        "storage_key": "property/6767906449166313/019d0266-1846-7759-82b9-c047b4b6279b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhaaqgtqhuokRDOQFnGtoOEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d6da33f4-c0f7-45db-87e9-c6d618fe491a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Western Branch Middle School",
      "poi_type": "Education",
      "poi_address": "4201 Hawksley Dr, Chesapeake, VA 23321, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.cpschools.com/o/wbm",
      "poi_directions_map_url": "https://maps.google.com/?cid=3942817869039171257&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "western-branch-middle-school",
      "poi_latitude": "36.8509592",
      "poi_longitude": "-76.40342439999999",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 757-638-7920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1846-7759-82b9-c047b4b6279b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1846-7759-82b9-c047b4b6279b",
        "storage_key": "property/6767906449166313/019d0266-1846-7759-82b9-c047b4b6279b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqWMJUNGhuokRuXYkQvaztzY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e1027d43-7762-4bc3-afe5-cd254dc67a35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Western Branch High School",
      "poi_type": "Education",
      "poi_address": "1968 Bruin Pl, Chesapeake, VA 23321, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-39b7-71ed-9242-7830e8fad9c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-39b7-71ed-9242-7830e8fad9c5",
        "storage_key": "property/6767906449166313/019fcdf4-39b7-71ed-9242-7830e8fad9c5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cpschools.com/o/wbh",
      "poi_directions_map_url": "https://maps.google.com/?cid=15753594564999766266&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "western-branch-high-school",
      "poi_latitude": "36.848105",
      "poi_longitude": "-76.4071428",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 757-638-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1846-7759-82b9-c047b4b6279b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1846-7759-82b9-c047b4b6279b",
        "storage_key": "property/6767906449166313/019d0266-1846-7759-82b9-c047b4b6279b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ91ugptOhuokR-uBVbsoCoNo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1375d84f-0888-4d29-bbfb-d307172219cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Jolliff Middle School",
      "poi_type": "Education",
      "poi_address": "1021 Jolliff Rd, Chesapeake, VA 23321, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-3a30-7529-9207-0062f70eb6c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-3a30-7529-9207-0062f70eb6c8",
        "storage_key": "property/6767906449166313/019fcdf4-3a30-7529-9207-0062f70eb6c8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cpschools.com/o/jms",
      "poi_directions_map_url": "https://maps.google.com/?cid=10369767328482881661&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jolliff-middle-school",
      "poi_latitude": "36.7897151",
      "poi_longitude": "-76.4171124",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 757-465-5246",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1846-7759-82b9-c047b4b6279b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1846-7759-82b9-c047b4b6279b",
        "storage_key": "property/6767906449166313/019d0266-1846-7759-82b9-c047b4b6279b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsXsw3N2guokRfXCsoXHQ6I8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_573fae4f-dcb3-49d8-8e4f-76c8f7516e1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "StoneBridge School",
      "poi_type": "Education",
      "poi_address": "1629 Jolliff Rd, Chesapeake, VA 23321, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-3b28-706a-b54c-f1d6e5f82087.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-3b28-706a-b54c-f1d6e5f82087",
        "storage_key": "property/6767906449166313/019fcdf4-3b28-706a-b54c-f1d6e5f82087.webp",
        "width": 720,
        "height": 540
      },
      "poi_business_url": "https://stonebridgeschool.com/?utm_source=google&utm_medium=organic&utm_campaign=GBP",
      "poi_directions_map_url": "https://maps.google.com/?cid=13956112219573389122&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stonebridge-school",
      "poi_latitude": "36.8024472",
      "poi_longitude": "-76.4376814",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 757-488-2214",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1846-7759-82b9-c047b4b6279b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1846-7759-82b9-c047b4b6279b",
        "storage_key": "property/6767906449166313/019d0266-1846-7759-82b9-c047b4b6279b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJycGvypOguokRQgcp_R4SrsE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bd0adf7b-f679-4d95-9f02-536c6ca35b18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "E W Chittum Elementary School",
      "poi_type": "Education",
      "poi_address": "2008 Dock Landing Rd, Chesapeake, VA 23321, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.cpschools.com/o/cht",
      "poi_directions_map_url": "https://maps.google.com/?cid=17310623967315730038&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "e-w-chittum-elementary-school",
      "poi_latitude": "36.8137194",
      "poi_longitude": "-76.40906989999999",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 757-465-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1846-7759-82b9-c047b4b6279b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1846-7759-82b9-c047b4b6279b",
        "storage_key": "property/6767906449166313/019d0266-1846-7759-82b9-c047b4b6279b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxd9ZrqqhuokRdp43XMiwO_A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_81ef289e-7782-4078-a789-2e459ad5296c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "La Petite Academy on Taylor Rd",
      "poi_type": "Education",
      "poi_address": "2453 Taylor Rd, Chesapeake, VA 23321, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-3ceb-7540-b334-8413502e9db5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-3ceb-7540-b334-8413502e9db5",
        "storage_key": "property/6767906449166313/019fcdf4-3ceb-7540-b334-8413502e9db5.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "https://www.lapetite.com/your-local-school/chesapeake-va-7136/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=7136",
      "poi_directions_map_url": "https://maps.google.com/?cid=14662423594076893494&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-petite-academy-on-taylor-rd",
      "poi_latitude": "36.8284731",
      "poi_longitude": "-76.4092077",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 877-271-6466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1846-7759-82b9-c047b4b6279b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1846-7759-82b9-c047b4b6279b",
        "storage_key": "property/6767906449166313/019d0266-1846-7759-82b9-c047b4b6279b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_2UfprShuokRNnFC75Jke8s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bfb0a38b-945d-484d-8033-83573655bc1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Creative World School - River Walk",
      "poi_type": "Education",
      "poi_address": "201 River Walk Pkwy, Chesapeake, VA 23320, USA",
      "poi_short_description": "Creative daycare and learning center serving babies, toddlers, preschoolers, and kids in kindergarten.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-3fb9-70e7-ac3d-eeb387eab73e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-3fb9-70e7-ac3d-eeb387eab73e",
        "storage_key": "property/6767906449166313/019fcdf4-3fb9-70e7-ac3d-eeb387eab73e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://creativeworldschool.com/schools/chesapeake-va-preschool-childcare-daycare/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3964246042413433468&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "creative-world-school---river-walk",
      "poi_latitude": "36.7433501",
      "poi_longitude": "-76.2580066",
      "poi_miles_from_property": "16.6 mi",
      "poi_walking_minutes": "6 hours 11 mins",
      "poi_biking_minutes": "1 hour 35 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 757-982-9444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1846-7759-82b9-c047b4b6279b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1846-7759-82b9-c047b4b6279b",
        "storage_key": "property/6767906449166313/019d0266-1846-7759-82b9-c047b4b6279b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4afJlFq7uokRfAJNqMXUAzc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_626c5ce9-d5e2-4d7b-a976-ee4eb8a86182",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Tidewater Community College - Chesapeake Campus",
      "poi_type": "Education",
      "poi_address": "1428 Cedar Rd, Chesapeake, VA 23322, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-4007-743f-b612-248c2df1fccd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-4007-743f-b612-248c2df1fccd",
        "storage_key": "property/6767906449166313/019fcdf4-4007-743f-b612-248c2df1fccd.webp",
        "width": 720,
        "height": 479
      },
      "poi_business_url": "https://www.tcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13381456670906503656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tidewater-community-college---chesapeake-campus",
      "poi_latitude": "36.7250759",
      "poi_longitude": "-76.2943994",
      "poi_miles_from_property": "16.5 mi",
      "poi_walking_minutes": "6 hours 3 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 757-822-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1846-7759-82b9-c047b4b6279b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1846-7759-82b9-c047b4b6279b",
        "storage_key": "property/6767906449166313/019d0266-1846-7759-82b9-c047b4b6279b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkUFGAeikuokR6NGptvF7tLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8621b81f-2a11-48f9-a928-d56f08946851",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Cinemark Chesapeake Square and XD",
      "poi_type": "Entertainment",
      "poi_address": "2413 Chesapeake Square Ring Rd, Chesapeake, VA 23321, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-4150-74fd-8326-ce33e731fd77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-4150-74fd-8326-ce33e731fd77",
        "storage_key": "property/6767906449166313/019fcdf4-4150-74fd-8326-ce33e731fd77.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/va-chesapeake/cinemark-chesapeake-square-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMwNDctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=15823021053310832591&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-chesapeake-square-and-xd",
      "poi_latitude": "36.8285779",
      "poi_longitude": "-76.4125316",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 757-488-4695",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-189d-74b8-8a1f-76aeb3c06e81.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-189d-74b8-8a1f-76aeb3c06e81",
        "storage_key": "property/6767906449166313/019d0266-189d-74b8-8a1f-76aeb3c06e81.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJp0EDjUuguokRz48eZNCplts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c1c4e77f-5d48-4f06-8b50-27220bee3d63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Oak Grove Lake Park",
      "poi_type": "Entertainment",
      "poi_address": "409 Byron St, Chesapeake, VA 23320, USA",
      "poi_short_description": "This 65-acre outdoor activity place has a 1.5-mi. path around a lake, plus benches & a playground.",
      "poi_long_description": "This 65-acre outdoor activity place has a 1.5-mi. path around a lake, plus benches & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-438b-709e-99ab-360040339989.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-438b-709e-99ab-360040339989",
        "storage_key": "property/6767906449166313/019fcdf4-438b-709e-99ab-360040339989.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofchesapeake.net/Facilities/Facility/Details/Oak-Grove-Lake-Park-102",
      "poi_directions_map_url": "https://maps.google.com/?cid=16071964790596609208&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-grove-lake-park",
      "poi_latitude": "36.7556385",
      "poi_longitude": "-76.2591747",
      "poi_miles_from_property": "16.4 mi",
      "poi_walking_minutes": "6 hours 4 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 757-382-6411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-21e0-716c-9b54-f8e47e44dad1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-21e0-716c-9b54-f8e47e44dad1",
        "storage_key": "property/6767906449166313/019d0266-21e0-716c-9b54-f8e47e44dad1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcz2tLqa8uokRuKQY-tIWC98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dafecd78-4a5b-42e6-be65-1c1227ecb9a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Chesapeake Arboretum",
      "poi_type": "Entertainment",
      "poi_address": "624 Oak Grove Rd, Chesapeake, VA 23320, USA",
      "poi_short_description": "Site devoted to nature appreciation & education, with forest trails & gardens across 45 acres.",
      "poi_long_description": "Site devoted to nature appreciation & education, with forest trails & gardens across 45 acres.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-46b4-71be-8380-c0b5ce1c8be4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-46b4-71be-8380-c0b5ce1c8be4",
        "storage_key": "property/6767906449166313/019fcdf4-46b4-71be-8380-c0b5ce1c8be4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofchesapeake.net/459/Chesapeake-Arboretum",
      "poi_directions_map_url": "https://maps.google.com/?cid=7837761785254882541&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chesapeake-arboretum",
      "poi_latitude": "36.743345",
      "poi_longitude": "-76.23922999999999",
      "poi_miles_from_property": "18.2 mi",
      "poi_walking_minutes": "6 hours 47 mins",
      "poi_biking_minutes": "1 hour 33 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 757-382-6411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-21e0-716c-9b54-f8e47e44dad1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-21e0-716c-9b54-f8e47e44dad1",
        "storage_key": "property/6767906449166313/019d0266-21e0-716c-9b54-f8e47e44dad1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGXXS1GS7uokR7aw_RNFSxWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5fd511b3-44d0-4b9e-8c44-6421c737b5a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Great Dismal Swamp National Wildlife Refuge",
      "poi_type": "Entertainment",
      "poi_address": "3100 Desert Rd, Suffolk, VA 23434, USA",
      "poi_short_description": "Home to birds, bears, otters & other animals, this vast preserve offers hunting, fishing & tours.",
      "poi_long_description": "Home to birds, bears, otters & other animals, this vast preserve offers hunting, fishing & tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-4749-76e7-9be3-75c50843b8a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-4749-76e7-9be3-75c50843b8a6",
        "storage_key": "property/6767906449166313/019fcdf4-4749-76e7-9be3-75c50843b8a6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fws.gov/refuge/great_dismal_swamp/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10942596731913900614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "great-dismal-swamp-national-wildlife-refuge",
      "poi_latitude": "36.61724299999999",
      "poi_longitude": "-76.46973349999999",
      "poi_miles_from_property": "23.8 mi",
      "poi_walking_minutes": "8 hours 37 mins",
      "poi_biking_minutes": "2 hours 2 mins",
      "poi_driving_minutes": "44 mins",
      "poi_business_phone": "+1 757-986-3705",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-21e0-716c-9b54-f8e47e44dad1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-21e0-716c-9b54-f8e47e44dad1",
        "storage_key": "property/6767906449166313/019d0266-21e0-716c-9b54-f8e47e44dad1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJR568lk8HsIkRRhIUVsDp25c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c87a457f-341c-4b09-9ee7-76ca493c554f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Children's Museum of Virginia",
      "poi_type": "Entertainment",
      "poi_address": "221 High St, Portsmouth, VA 23704, USA",
      "poi_short_description": "Hands-on exhibits explore cities, space, music, energy, the human body & more, plus antique trains.",
      "poi_long_description": "Hands-on exhibits explore cities, space, music, energy, the human body & more, plus antique trains.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-4815-70f9-80aa-52c9dcceed25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-4815-70f9-80aa-52c9dcceed25",
        "storage_key": "property/6767906449166313/019fcdf4-4815-70f9-80aa-52c9dcceed25.webp",
        "width": 604,
        "height": 340
      },
      "poi_business_url": "https://childrensmuseumvirginia.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12121064137297541948&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-museum-of-virginia",
      "poi_latitude": "36.835",
      "poi_longitude": "-76.2988889",
      "poi_miles_from_property": "10.7 mi",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 757-393-5258",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1e4f-75e7-9eca-cc5ddb8107f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1e4f-75e7-9eca-cc5ddb8107f1",
        "storage_key": "property/6767906449166313/019d0266-1e4f-75e7-9eca-cc5ddb8107f1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJzdBNaZmiuokRPLtY25yrNqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4860edf3-7ebc-4802-a031-dc33aaf23aa8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Portsmouth Naval Shipyard Museum",
      "poi_type": "Entertainment",
      "poi_address": "2 High St, Portsmouth, VA 23704, USA",
      "poi_short_description": "Museum displaying models, military artifacts & exhibits on naval shipyard & shipbuilding history.",
      "poi_long_description": "Museum displaying models, military artifacts & exhibits on naval shipyard & shipbuilding history.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-4a47-71dd-a3ce-6b867be34841.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-4a47-71dd-a3ce-6b867be34841",
        "storage_key": "property/6767906449166313/019fcdf4-4a47-71dd-a3ce-6b867be34841.webp",
        "width": 1280,
        "height": 741
      },
      "poi_business_url": "http://www.portsmouthnavalshipyardmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16705804865930178570&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "portsmouth-naval-shipyard-museum",
      "poi_latitude": "36.8359451",
      "poi_longitude": "-76.2967333",
      "poi_miles_from_property": "10.8 mi",
      "poi_walking_minutes": "4 hours 1 min",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 757-393-8591",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1e4f-75e7-9eca-cc5ddb8107f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1e4f-75e7-9eca-cc5ddb8107f1",
        "storage_key": "property/6767906449166313/019d0266-1e4f-75e7-9eca-cc5ddb8107f1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJez1a0ZiiuokRCrDCsAPx1uc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_875fd5c3-eea2-42d3-a37f-f9fb0f6167cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Nauticus",
      "poi_type": "Entertainment",
      "poi_address": "1 Waterside Dr Suite 248, Norfolk, VA 23510, USA",
      "poi_short_description": "Waterfront maritime museum with science exhibits, an aquarium & a historic battleship.",
      "poi_long_description": "Waterfront maritime museum with science exhibits, an aquarium & a historic battleship.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-4d04-770a-8226-5776c3adb1fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-4d04-770a-8226-5776c3adb1fe",
        "storage_key": "property/6767906449166313/019fcdf4-4d04-770a-8226-5776c3adb1fe.webp",
        "width": 960,
        "height": 539
      },
      "poi_business_url": "http://www.nauticus.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=320581371750534560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nauticus",
      "poi_latitude": "36.8477024",
      "poi_longitude": "-76.29509139999999",
      "poi_miles_from_property": "12.1 mi",
      "poi_walking_minutes": "4 hours 18 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 757-664-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1e4f-75e7-9eca-cc5ddb8107f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1e4f-75e7-9eca-cc5ddb8107f1",
        "storage_key": "property/6767906449166313/019d0266-1e4f-75e7-9eca-cc5ddb8107f1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJiQ2IUnOYuokRoE3MIA_vcgQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ee6d6008-9a37-4d66-8bf1-30b94dc85dbf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Chrysler Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "Chrysler Museum of Art, 1 Memorial Pl, Norfolk, VA 23510, USA",
      "poi_short_description": "Esteemed museum with a broad collection of ancient to contemporary art, including glass & sculpture.",
      "poi_long_description": "Esteemed museum with a broad collection of ancient to contemporary art, including glass & sculpture.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-4ea4-7139-8f28-952f32c2f55d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-4ea4-7139-8f28-952f32c2f55d",
        "storage_key": "property/6767906449166313/019fcdf4-4ea4-7139-8f28-952f32c2f55d.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.chrysler.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15237537796494747209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chrysler-museum-of-art",
      "poi_latitude": "36.8563889",
      "poi_longitude": "-76.2930556",
      "poi_miles_from_property": "12.7 mi",
      "poi_walking_minutes": "4 hours 32 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 757-664-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1e4f-75e7-9eca-cc5ddb8107f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1e4f-75e7-9eca-cc5ddb8107f1",
        "storage_key": "property/6767906449166313/019d0266-1e4f-75e7-9eca-cc5ddb8107f1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwT-nRSYuokRSWao2-SbdtM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_959f0ee1-8f99-4b6d-8e64-7a0c0493e79e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "The NorVa",
      "poi_type": "Entertainment",
      "poi_address": "317 Monticello Ave, Norfolk, VA 23510, USA",
      "poi_short_description": "Downtown music venue for national indie bands with a general admission floor & a small balcony.",
      "poi_long_description": "Downtown music venue for national indie bands with a general admission floor & a small balcony.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-4e98-7739-b0e0-478c6fd2d136.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-4e98-7739-b0e0-478c6fd2d136",
        "storage_key": "property/6767906449166313/019fcdf4-4e98-7739-b0e0-478c6fd2d136.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "http://www.thenorva.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10866326690772284751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-norva",
      "poi_latitude": "36.850189",
      "poi_longitude": "-76.28949999999999",
      "poi_miles_from_property": "12.1 mi",
      "poi_walking_minutes": "4 hours 20 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 757-627-4547",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1847-7618-a1ea-a342213bb793",
        "storage_key": "property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBXJH6Q2YuokRT_XTkI3yzJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_33da1572-2ab0-46bb-b565-4b8af8ca0367",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Virginia Zoo",
      "poi_type": "Entertainment",
      "poi_address": "3500 Granby St, Norfolk, VA 23504, USA",
      "poi_short_description": "Sprawling park with 700+ animals from 150+ species, plus tours, gardens & kids' camps.",
      "poi_long_description": "Sprawling park with 700+ animals from 150+ species, plus tours, gardens & kids' camps.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-5176-74f8-be82-3ac2c1e4514f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-5176-74f8-be82-3ac2c1e4514f",
        "storage_key": "property/6767906449166313/019fcdf4-5176-74f8-be82-3ac2c1e4514f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.virginiazoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1690277800201406272&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virginia-zoo",
      "poi_latitude": "36.8767691",
      "poi_longitude": "-76.2771229",
      "poi_miles_from_property": "14.2 mi",
      "poi_walking_minutes": "5 hours 9 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 757-441-2374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1847-7618-a1ea-a342213bb793",
        "storage_key": "property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoXYXhiuYuokRQMe7LLQSdRc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d6dbe1bb-8e54-47a3-8d34-9dee6506049e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Bon Secours Maryview Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3636 High St, Portsmouth, VA 23707, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-538e-76c8-bf5c-07f6ebab80fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-538e-76c8-bf5c-07f6ebab80fb",
        "storage_key": "property/6767906449166313/019fcdf4-538e-76c8-bf5c-07f6ebab80fb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bonsecours.com/locations/hospitals-medical-centers/hampton-roads/bon-secours-maryview-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=13347833568345516817&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bon-secours-maryview-medical-center",
      "poi_latitude": "36.8361964",
      "poi_longitude": "-76.3472529",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 757-398-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1847-7618-a1ea-a342213bb793",
        "storage_key": "property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ49Iw_RGiuokREetEGukHPbk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_30665a41-c67a-4c74-9ee6-e59ddde87d82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "AFC Urgent Care Chesapeake",
      "poi_type": "Health and Wellness",
      "poi_address": "325 Volvo Pkwy, Chesapeake, VA 23320, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-5500-7357-aac0-c879bb0c4d80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-5500-7357-aac0-c879bb0c4d80",
        "storage_key": "property/6767906449166313/019fcdf4-5500-7357-aac0-c879bb0c4d80.webp",
        "width": 1280,
        "height": 836
      },
      "poi_business_url": "https://www.afcurgentcare.com/chesapeake/?utm_source=gmb&utm_medium=organic&utm_campaign=afc-chesapeake",
      "poi_directions_map_url": "https://maps.google.com/?cid=17160490016554942411&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "afc-urgent-care-chesapeake",
      "poi_latitude": "36.7650334",
      "poi_longitude": "-76.24630429999999",
      "poi_miles_from_property": "16.5 mi",
      "poi_walking_minutes": "6 hours 10 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 757-240-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1847-7618-a1ea-a342213bb793",
        "storage_key": "property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRaO_ni-9uokRy_9k-L9OJu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c7bcf840-f1db-473a-9322-25256aaf7c4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "CHKD Pediatric Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "817 Volvo Pkwy, Chesapeake, VA 23320, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-54e0-7437-b7ac-b9dae4a6deb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-54e0-7437-b7ac-b9dae4a6deb1",
        "storage_key": "property/6767906449166313/019fcdf4-54e0-7437-b7ac-b9dae4a6deb1.webp",
        "width": 1060,
        "height": 596
      },
      "poi_business_url": "https://www.chkd.org/locations/chkd-pediatric-urgent-care-at-volvo/?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=2519305335403152566&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chkd-pediatric-urgent-care",
      "poi_latitude": "36.76817",
      "poi_longitude": "-76.2294496",
      "poi_miles_from_property": "17.5 mi",
      "poi_walking_minutes": "6 hours 32 mins",
      "poi_biking_minutes": "1 hour 31 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 757-668-4630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1847-7618-a1ea-a342213bb793",
        "storage_key": "property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtwCe3oq8uokRtoRzzdpe9iI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d6a5e092-a7f4-461d-b946-7d9961867616",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1329 Kempsville Rd, Chesapeake, VA 23320, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-578f-75fe-986f-a86bd5f96f04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-578f-75fe-986f-a86bd5f96f04",
        "storage_key": "property/6767906449166313/019fcdf4-578f-75fe-986f-a86bd5f96f04.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/chesapeake-va-pharmacies/1329-kempsville-rd-chesapeake-va-23320/storeid=255?WT.mc_id=LS_GOOGLE_RX_255",
      "poi_directions_map_url": "https://maps.google.com/?cid=9065135060654954573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "36.7625676",
      "poi_longitude": "-76.2045657",
      "poi_miles_from_property": "19.0 mi",
      "poi_walking_minutes": "7 hours 4 mins",
      "poi_biking_minutes": "1 hour 38 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 757-312-0502",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1e04-74fb-ac5e-a6513c769257.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1e04-74fb-ac5e-a6513c769257",
        "storage_key": "property/6767906449166313/019d0266-1e04-74fb-ac5e-a6513c769257.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzWhBgmu8uokRTRhH-07UzX0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b13a0bbf-a002-45d2-b5d5-13fd90bbc953",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1200 Greenbrier Pkwy, Chesapeake, VA 23320, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-5a6c-72d8-8395-de43af164e45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-5a6c-72d8-8395-de43af164e45",
        "storage_key": "property/6767906449166313/019fcdf4-5a6c-72d8-8395-de43af164e45.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1200+greenbrier+pkwy-chesapeake-va-23320/id=13474",
      "poi_directions_map_url": "https://maps.google.com/?cid=11078208809117828363&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "36.7696769",
      "poi_longitude": "-76.2285724",
      "poi_miles_from_property": "17.6 mi",
      "poi_walking_minutes": "6 hours 34 mins",
      "poi_biking_minutes": "1 hour 31 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 757-548-0165",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1847-7618-a1ea-a342213bb793",
        "storage_key": "property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQdkTMIu8uokRC0USjze0vZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4742ab65-8812-40cd-89ea-5d61431ec5f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Health and Wellness",
      "poi_address": "475 Kempsville Rd, Chesapeake, VA 23320, USA",
      "poi_short_description": "Neighborhood chain discount grocery store with a deli, bakery, and pharmacy, plus check cashing.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-5baf-74cb-b41a-272f0ee60435.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-5baf-74cb-b41a-272f0ee60435",
        "storage_key": "property/6767906449166313/019fcdf4-5baf-74cb-b41a-272f0ee60435.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/3299-chesapeake-va/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=9012570253914069216&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "36.743978",
      "poi_longitude": "-76.2255514",
      "poi_miles_from_property": "18.8 mi",
      "poi_walking_minutes": "7 hours 0 mins",
      "poi_biking_minutes": "1 hour 35 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 757-447-9223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-139e-72d1-817a-b95df0b32acf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-139e-72d1-817a-b95df0b32acf",
        "storage_key": "property/6767906449166313/019d0266-139e-72d1-817a-b95df0b32acf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCarzqHi7uokR4NjMMeUUE30",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b8b1aac3-4da9-4843-afaf-841cf5473258",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1620 Sentinel Dr, Chesapeake, VA 23320, USA",
      "poi_short_description": "Chain gym offering a variety of equipment, massage chairs, and tanning, plus 24-hour access.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-5bd1-732b-97e8-61118af99a56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-5bd1-732b-97e8-61118af99a56",
        "storage_key": "property/6767906449166313/019fcdf4-5bd1-732b-97e8-61118af99a56.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/chesapeake-va?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=10973402979607351215&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.7767205",
      "poi_longitude": "-76.2528044",
      "poi_miles_from_property": "15.6 mi",
      "poi_walking_minutes": "5 hours 49 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 757-330-5289",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1847-7618-a1ea-a342213bb793",
        "storage_key": "property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCZV5QG29uokRr4-10N5bSZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d6eb6042-8966-4b2d-865d-81eb439fe9ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Greenbrier Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "1033 Greenbrier Pkwy, Chesapeake, VA 23320, USA",
      "poi_short_description": "Family-oriented health club offering a swimming pool, basketball and tennis courts, a sauna, and childcare.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-5dd4-7598-b7a6-0e35225bc414.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-5dd4-7598-b7a6-0e35225bc414",
        "storage_key": "property/6767906449166313/019fcdf4-5dd4-7598-b7a6-0e35225bc414.webp",
        "width": 1000,
        "height": 385
      },
      "poi_business_url": "http://www.ymcashr.org/greenbrier",
      "poi_directions_map_url": "https://maps.google.com/?cid=17342115582976784801&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greenbrier-family-ymca",
      "poi_latitude": "36.7613964",
      "poi_longitude": "-76.2235597",
      "poi_miles_from_property": "18.3 mi",
      "poi_walking_minutes": "6 hours 48 mins",
      "poi_biking_minutes": "1 hour 35 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 757-547-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1847-7618-a1ea-a342213bb793",
        "storage_key": "property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUYPRClS8uokRofkYgT2Sq_A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ca63c354-24bb-4129-8ef0-e80eb4169a04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "801 Volvo Pkwy #138, Chesapeake, VA 23320, USA",
      "poi_short_description": "Fitness center offering cardio and strength training as part of full-body group workouts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-6085-76a9-a5e7-e64086d9c544.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-6085-76a9-a5e7-e64086d9c544",
        "storage_key": "property/6767906449166313/019fcdf4-6085-76a9-a5e7-e64086d9c544.webp",
        "width": 1280,
        "height": 627
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/chesapeake-virginia-1027?utm_medium=seo&utm_source=gg&utm_term=tombras&utm_campaign=reputationdotcom--National",
      "poi_directions_map_url": "https://maps.google.com/?cid=2991583180611929938&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "36.7673941",
      "poi_longitude": "-76.2296878",
      "poi_miles_from_property": "17.6 mi",
      "poi_walking_minutes": "6 hours 33 mins",
      "poi_biking_minutes": "1 hour 31 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 757-335-6896",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1847-7618-a1ea-a342213bb793",
        "storage_key": "property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJidhtt1m9uokRUkdofA09hCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c21460c1-70f0-46b2-9ed5-8dbe002deaba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Pure Barre",
      "poi_type": "Health and Wellness",
      "poi_address": "733 Eden Way N #406, Chesapeake, VA 23320, USA",
      "poi_short_description": "Gym offering yoga-inspired ballet- and Pilates-inspired barre classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-610b-77ee-975e-4a58f9089d73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-610b-77ee-975e-4a58f9089d73",
        "storage_key": "property/6767906449166313/019fcdf4-610b-77ee-975e-4a58f9089d73.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.purebarre.com/location/chesapeake-va",
      "poi_directions_map_url": "https://maps.google.com/?cid=14319805212579127259&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pure-barre",
      "poi_latitude": "36.7712387",
      "poi_longitude": "-76.2363221",
      "poi_miles_from_property": "17.5 mi",
      "poi_walking_minutes": "6 hours 31 mins",
      "poi_biking_minutes": "1 hour 32 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 757-842-4288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1847-7618-a1ea-a342213bb793",
        "storage_key": "property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6cg5rZS8uokR29-QpPgqusY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_389c9c29-fe1b-46c2-9628-e0170d01ed59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Hoffler Creek Wildlife Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4510 Twin Pines Rd, Portsmouth, VA 23703, USA",
      "poi_short_description": "Free wooded park, with a large lake, featuring a nature trail and kayak rentals.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-6243-7449-987a-665067e0e5ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-6243-7449-987a-665067e0e5ad",
        "storage_key": "property/6767906449166313/019fcdf4-6243-7449-987a-665067e0e5ad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hofflercreek.org/?utm_source=google&utm_medium=wix_google_business_profile&utm_campaign=8259904898249720874",
      "poi_directions_map_url": "https://maps.google.com/?cid=10049486857708129621&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hoffler-creek-wildlife-preserve",
      "poi_latitude": "36.8926068",
      "poi_longitude": "-76.3953496",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 757-686-8684",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-21e0-716c-9b54-f8e47e44dad1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-21e0-716c-9b54-f8e47e44dad1",
        "storage_key": "property/6767906449166313/019d0266-21e0-716c-9b54-f8e47e44dad1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJG_JrGQOfuokRVU2meA3zdos",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_84a73023-c26f-428b-97a5-e69ddf44e1a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Oak Grove Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "409 Byron St, Chesapeake, VA 23320, USA",
      "poi_short_description": "This 65-acre outdoor activity place has a 1.5-mi. path around a lake, plus benches & a playground.",
      "poi_long_description": "This 65-acre outdoor activity place has a 1.5-mi. path around a lake, plus benches & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-438b-709e-99ab-360040339989.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-438b-709e-99ab-360040339989",
        "storage_key": "property/6767906449166313/019fcdf4-438b-709e-99ab-360040339989.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofchesapeake.net/Facilities/Facility/Details/Oak-Grove-Lake-Park-102",
      "poi_directions_map_url": "https://maps.google.com/?cid=16071964790596609208&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-grove-lake-park",
      "poi_latitude": "36.7556385",
      "poi_longitude": "-76.2591747",
      "poi_miles_from_property": "16.4 mi",
      "poi_walking_minutes": "6 hours 4 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 757-382-6411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-21e0-716c-9b54-f8e47e44dad1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-21e0-716c-9b54-f8e47e44dad1",
        "storage_key": "property/6767906449166313/019d0266-21e0-716c-9b54-f8e47e44dad1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcz2tLqa8uokRuKQY-tIWC98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c248bd32-f370-4f74-9ed2-b7d20e53ea96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Chesapeake Arboretum",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "624 Oak Grove Rd, Chesapeake, VA 23320, USA",
      "poi_short_description": "Site devoted to nature appreciation & education, with forest trails & gardens across 45 acres.",
      "poi_long_description": "Site devoted to nature appreciation & education, with forest trails & gardens across 45 acres.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-46b4-71be-8380-c0b5ce1c8be4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-46b4-71be-8380-c0b5ce1c8be4",
        "storage_key": "property/6767906449166313/019fcdf4-46b4-71be-8380-c0b5ce1c8be4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofchesapeake.net/459/Chesapeake-Arboretum",
      "poi_directions_map_url": "https://maps.google.com/?cid=7837761785254882541&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chesapeake-arboretum",
      "poi_latitude": "36.743345",
      "poi_longitude": "-76.23922999999999",
      "poi_miles_from_property": "18.2 mi",
      "poi_walking_minutes": "6 hours 47 mins",
      "poi_biking_minutes": "1 hour 33 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 757-382-6411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-21e0-716c-9b54-f8e47e44dad1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-21e0-716c-9b54-f8e47e44dad1",
        "storage_key": "property/6767906449166313/019d0266-21e0-716c-9b54-f8e47e44dad1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGXXS1GS7uokR7aw_RNFSxWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cc48bb60-7b67-48dd-860b-60fc9ee984ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Western Branch Community Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4437 Portsmouth Blvd, Chesapeake, VA 23321, USA",
      "poi_short_description": "Tree-shaded option for community gatherings with a variety of ball fields & a playground.",
      "poi_long_description": "Tree-shaded option for community gatherings with a variety of ball fields & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-6529-75c6-83f0-e81df4e0acec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-6529-75c6-83f0-e81df4e0acec",
        "storage_key": "property/6767906449166313/019fcdf4-6529-75c6-83f0-e81df4e0acec.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cityofchesapeake.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17197827583742493765&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "western-branch-community-center",
      "poi_latitude": "36.8203688",
      "poi_longitude": "-76.4229548",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 757-465-0211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1847-7618-a1ea-a342213bb793",
        "storage_key": "property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh7YfGFiguokRRcRixRH1qu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d2856841-35a5-4b7d-9700-66b8c0c291c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Northwest River Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1733 Indian Creek Rd, Chesapeake, VA 23322, USA",
      "poi_short_description": "Riverside park offering fishing, boating, camping, horse riding, putt-putt & more. Open year-round.",
      "poi_long_description": "Riverside park offering fishing, boating, camping, horse riding, putt-putt & more. Open year-round.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-6783-7149-88a2-cef63b2f2c30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-6783-7149-88a2-cef63b2f2c30",
        "storage_key": "property/6767906449166313/019fcdf4-6783-7149-88a2-cef63b2f2c30.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofchesapeake.net/499/Northwest-River-Park-Campground",
      "poi_directions_map_url": "https://maps.google.com/?cid=572435889717953805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-river-park",
      "poi_latitude": "36.5861149",
      "poi_longitude": "-76.1526456",
      "poi_miles_from_property": "31.9 mi",
      "poi_walking_minutes": "11 hours 45 mins",
      "poi_biking_minutes": "2 hours 38 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "+1 757-421-7151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-21e0-716c-9b54-f8e47e44dad1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-21e0-716c-9b54-f8e47e44dad1",
        "storage_key": "property/6767906449166313/019d0266-21e0-716c-9b54-f8e47e44dad1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgUcuUZi2uokRDcVSp2iz8Qc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_94abdc72-b31f-45b1-8261-6a0377f63c1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Dismal Swamp Canal Trail Parking",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1200 Dismal Swamp Canal Trail, Chesapeake, VA 23322, USA",
      "poi_short_description": "Flat, paved 11-mi. trail for walking, bicycling & horseback riding, with a boat ramp & picnic area.",
      "poi_long_description": "Flat, paved 11-mi. trail for walking, bicycling & horseback riding, with a boat ramp & picnic area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-6826-730b-8ee4-9eaefeccccdd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-6826-730b-8ee4-9eaefeccccdd",
        "storage_key": "property/6767906449166313/019fcdf4-6826-730b-8ee4-9eaefeccccdd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11385281685750297101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dismal-swamp-canal-trail-parking",
      "poi_latitude": "36.68945550000001",
      "poi_longitude": "-76.3590031",
      "poi_miles_from_property": "17.0 mi",
      "poi_walking_minutes": "6 hours 14 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 757-382-6411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-22ad-721f-982f-ac03a61dd4cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-22ad-721f-982f-ac03a61dd4cc",
        "storage_key": "property/6767906449166313/019d0266-22ad-721f-982f-ac03a61dd4cc.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJXbRWfuOluokRDTLoEl-lAJ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c349547c-8240-4ef2-aeb3-c0fd9bb8a24a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Deep Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "437 George Washington Hwy S, Chesapeake, VA 23323, USA",
      "poi_short_description": "City park with several ball fields, a dog run, playground, walking trail & picnic/grilling areas.",
      "poi_long_description": "City park with several ball fields, a dog run, playground, walking trail & picnic/grilling areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-69a6-776b-8c82-d3c3740f00fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-69a6-776b-8c82-d3c3740f00fe",
        "storage_key": "property/6767906449166313/019fcdf4-69a6-776b-8c82-d3c3740f00fe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofchesapeake.net/facilities/facility/details/Deep-Creek-Park-94",
      "poi_directions_map_url": "https://maps.google.com/?cid=11051875228870833454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deep-creek-park",
      "poi_latitude": "36.7223671",
      "poi_longitude": "-76.34585419999999",
      "poi_miles_from_property": "14.8 mi",
      "poi_walking_minutes": "5 hours 26 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 757-382-6411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-21e0-716c-9b54-f8e47e44dad1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-21e0-716c-9b54-f8e47e44dad1",
        "storage_key": "property/6767906449166313/019d0266-21e0-716c-9b54-f8e47e44dad1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJpZNCzzOkuokRLvXIHvclYJk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2e04de31-4569-4500-a1e8-ec34623c3c4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Great Bridge Lock Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 Locks Rd, Chesapeake, VA 23320, USA",
      "poi_short_description": "Island park featuring a playground, fishing area, boat ramp, observation beam & picnic shelters.",
      "poi_long_description": "Island park featuring a playground, fishing area, boat ramp, observation beam & picnic shelters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-6be7-70d0-8287-9df48a697162.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-6be7-70d0-8287-9df48a697162",
        "storage_key": "property/6767906449166313/019fcdf4-6be7-70d0-8287-9df48a697162.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofchesapeake.net/facilities/facility/details/Great-Bridge-Lock-Park-97",
      "poi_directions_map_url": "https://maps.google.com/?cid=18139171555178903483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "great-bridge-lock-park",
      "poi_latitude": "36.7241823",
      "poi_longitude": "-76.24775420000002",
      "poi_miles_from_property": "18.9 mi",
      "poi_walking_minutes": "7 hours 1 min",
      "poi_biking_minutes": "1 hour 40 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 757-382-6411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-21e0-716c-9b54-f8e47e44dad1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-21e0-716c-9b54-f8e47e44dad1",
        "storage_key": "property/6767906449166313/019d0266-21e0-716c-9b54-f8e47e44dad1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkdV-Aha7uokRu_dOimxIu_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e4d325f5-f6e6-45fd-979a-9167d85e0e6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Paradise Creek Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1141 Victory Blvd, Portsmouth, VA 23702, USA",
      "poi_short_description": "Restored wetlands on the Elizabeth River with nature & fitness trails, a kayak launch & picnic area.",
      "poi_long_description": "Restored wetlands on the Elizabeth River with nature & fitness trails, a kayak launch & picnic area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-6e18-71ef-b8bb-3a9f959997af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-6e18-71ef-b8bb-3a9f959997af",
        "storage_key": "property/6767906449166313/019fcdf4-6e18-71ef-b8bb-3a9f959997af.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://elizabethriver.org/paradise-creek-nature-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11337379056136585319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paradise-creek-nature-park",
      "poi_latitude": "36.798312",
      "poi_longitude": "-76.308414",
      "poi_miles_from_property": "10.5 mi",
      "poi_walking_minutes": "3 hours 55 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 757-399-7487",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-21e0-716c-9b54-f8e47e44dad1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-21e0-716c-9b54-f8e47e44dad1",
        "storage_key": "property/6767906449166313/019d0266-21e0-716c-9b54-f8e47e44dad1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJv4V37wKjuokRZ4D5_C52Vp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_22784ebd-f4dd-4817-87c2-49e83859512d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Elizabeth River Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1400 Elizabeth River Way, Chesapeake, VA 23324, USA",
      "poi_short_description": "Pier and dog park under the Jordan Bridge, with picnic tables and a boat ramp, as well as a playground.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-7029-7633-a9a4-fea886af1971.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-7029-7633-a9a4-fea886af1971",
        "storage_key": "property/6767906449166313/019fcdf4-7029-7633-a9a4-fea886af1971.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cityofchesapeake.net/Facilities/Facility/Details/Elizabeth-River-Park-96",
      "poi_directions_map_url": "https://maps.google.com/?cid=2855118547890518513&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elizabeth-river-park",
      "poi_latitude": "36.8092188",
      "poi_longitude": "-76.2858004",
      "poi_miles_from_property": "12.1 mi",
      "poi_walking_minutes": "4 hours 29 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 757-382-6411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-21e0-716c-9b54-f8e47e44dad1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-21e0-716c-9b54-f8e47e44dad1",
        "storage_key": "property/6767906449166313/019d0266-21e0-716c-9b54-f8e47e44dad1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJj2zWF8WiuokR8bmkNjFrnyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fdd3429c-7edb-426c-bc55-dd2ef2de2223",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Downtown Norfolk Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "434 St Pauls Blvd, Norfolk, VA 23510, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-7033-7258-9bec-301e322fc109.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-7033-7258-9bec-301e322fc109",
        "storage_key": "property/6767906449166313/019fcdf4-7033-7258-9bec-301e322fc109.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://gohrt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13399495778541850642&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-norfolk-transit-center",
      "poi_latitude": "36.8507482",
      "poi_longitude": "-76.2836909",
      "poi_miles_from_property": "12.3 mi",
      "poi_walking_minutes": "4 hours 25 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 757-222-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-234c-764b-b60f-ec0865f3c834.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-234c-764b-b60f-ec0865f3c834",
        "storage_key": "property/6767906449166313/019d0266-234c-764b-b60f-ec0865f3c834.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7e5PBRCYuokRElBVwWqS9Lk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5613a3bd-b05f-4176-9921-373405829acd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Amtrak station",
      "poi_type": "Transportation & Transit",
      "poi_address": "280 Park Ave, Norfolk, VA 23510, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-726f-773a-ab2a-5ab2c085874d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-726f-773a-ab2a-5ab2c085874d",
        "storage_key": "property/6767906449166313/019fcdf4-726f-773a-ab2a-5ab2c085874d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.amtrak.com/stations/nfk",
      "poi_directions_map_url": "https://maps.google.com/?cid=5786992787379992599&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amtrak-station",
      "poi_latitude": "36.8434382",
      "poi_longitude": "-76.2761393",
      "poi_miles_from_property": "12.5 mi",
      "poi_walking_minutes": "4 hours 26 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 866-332-0824",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1847-7618-a1ea-a342213bb793",
        "storage_key": "property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2fruOx-XuokRFziIgUeHT1A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d7066b39-a7e7-47f7-be0e-f88b0af491b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Norfolk International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2200 Norview Ave, Norfolk, VA 23518, USA",
      "poi_short_description": "Hub serving the Southeast & offering a lounge for active & retired military personnel.",
      "poi_long_description": "Hub serving the Southeast & offering a lounge for active & retired military personnel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-7456-72ad-b713-f5cf3c137255.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-7456-72ad-b713-f5cf3c137255",
        "storage_key": "property/6767906449166313/019fcdf4-7456-72ad-b713-f5cf3c137255.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.flyorf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12156428893607189990&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "norfolk-international-airport",
      "poi_latitude": "36.8935106",
      "poi_longitude": "-76.1993707",
      "poi_miles_from_property": "18.6 mi",
      "poi_walking_minutes": "6 hours 45 mins",
      "poi_biking_minutes": "1 hour 29 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 757-857-3351",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-22c7-703f-b9e2-e91b5a8308f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-22c7-703f-b9e2-e91b5a8308f9",
        "storage_key": "property/6767906449166313/019d0266-22c7-703f-b9e2-e91b5a8308f9.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJOd96j8OWuokR5l3A1KtPtKg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9daa21a1-1ac3-4982-9bfd-0a47dda72f70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Newtown Road Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Norfolk, VA 23502, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-7775-751c-83ea-0ea339fc108a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-7775-751c-83ea-0ea339fc108a",
        "storage_key": "property/6767906449166313/019fcdf4-7775-751c-83ea-0ea339fc108a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6058645202623328844&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newtown-road-station",
      "poi_latitude": "36.841048",
      "poi_longitude": "-76.190226",
      "poi_miles_from_property": "18.3 mi",
      "poi_walking_minutes": "6 hours 37 mins",
      "poi_biking_minutes": "1 hour 34 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019f950f-9fa5-7451-b96c-9dc8358c7564.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f950f-9fa5-7451-b96c-9dc8358c7564",
        "storage_key": "property/6767906449166313/019f950f-9fa5-7451-b96c-9dc8358c7564.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7Yq-IRCWuokRTPJ8MrahFFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_21a77c6a-fd57-4096-801e-21ad9b54536c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Liberty & Seaboard",
      "poi_type": "Transportation & Transit",
      "poi_address": "Chesapeake, VA 23324, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10496350367983609484&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "liberty--seaboard",
      "poi_latitude": "36.823061",
      "poi_longitude": "-76.275027",
      "poi_miles_from_property": "12.9 mi",
      "poi_walking_minutes": "4 hours 47 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1847-7618-a1ea-a342213bb793",
        "storage_key": "property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo37ZdbSiuokRjCa0MQyHqpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_23b4cfe8-7901-4d56-a6a4-e05bc4fc117b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Robert Hall & Military",
      "poi_type": "Transportation & Transit",
      "poi_address": "Chesapeake, VA 23320, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13548304539125550686&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "robert-hall--military",
      "poi_latitude": "36.786824",
      "poi_longitude": "-76.256215",
      "poi_miles_from_property": "15.0 mi",
      "poi_walking_minutes": "5 hours 34 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1847-7618-a1ea-a342213bb793",
        "storage_key": "property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL_20B9u8uokRXg5kQzI_Bbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_345f3c41-644d-46d0-9d77-55c9eff6befc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Silverleaf Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "4300 Commuter Dr #7446, Virginia Beach, VA 23462, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-7712-714e-a995-c106d03aad96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-7712-714e-a995-c106d03aad96",
        "storage_key": "property/6767906449166313/019fcdf4-7712-714e-a995-c106d03aad96.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://gohrt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7843017891399587695&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "silverleaf-transit-center",
      "poi_latitude": "36.8208849",
      "poi_longitude": "-76.125185",
      "poi_miles_from_property": "22.0 mi",
      "poi_walking_minutes": "8 hours 10 mins",
      "poi_biking_minutes": "2 hours 2 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 757-222-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1847-7618-a1ea-a342213bb793",
        "storage_key": "property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRzPLG9a_uokRb9fn1zf_12w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1de62a7d-9c6d-4170-abc5-204cf0da92d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Hampton Roads Transit",
      "poi_type": "Transportation & Transit",
      "poi_address": "509 E 18th St, Norfolk, VA 23504, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-78ce-7748-8369-aea24eb4afc7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-78ce-7748-8369-aea24eb4afc7",
        "storage_key": "property/6767906449166313/019fcdf4-78ce-7748-8369-aea24eb4afc7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://gohrt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2044346889551823457&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hampton-roads-transit",
      "poi_latitude": "36.8643856",
      "poi_longitude": "-76.28369479999999",
      "poi_miles_from_property": "13.2 mi",
      "poi_walking_minutes": "4 hours 45 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 757-222-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1847-7618-a1ea-a342213bb793",
        "storage_key": "property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI2ezoT2YuokRYUJpJar6Xhw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a738be10-7f47-4c69-a26e-6a9ccd801278",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Chesapeake Square HRT Transfer Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Chesapeake, VA 23321, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14511632251865070488&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chesapeake-square-hrt-transfer-station",
      "poi_latitude": "36.821907",
      "poi_longitude": "-76.421402",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-234c-764b-b60f-ec0865f3c834.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-234c-764b-b60f-ec0865f3c834",
        "storage_key": "property/6767906449166313/019d0266-234c-764b-b60f-ec0865f3c834.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJR2pUflCguokRmPuEq6WsY8k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_995f4953-8b87-4cdb-86c2-a476dbf97012",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Dollar Tree Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 Volvo Pkwy, Chesapeake, VA 23320, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-7ad2-73db-b3be-37b3b8c6e68a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-7ad2-73db-b3be-37b3b8c6e68a",
        "storage_key": "property/6767906449166313/019fcdf4-7ad2-73db-b3be-37b3b8c6e68a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.dollartree.com/work",
      "poi_directions_map_url": "https://maps.google.com/?cid=12059028410693697369&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree-corporate-office",
      "poi_latitude": "36.7683602",
      "poi_longitude": "-76.24191309999999",
      "poi_miles_from_property": "16.9 mi",
      "poi_walking_minutes": "6 hours 18 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 757-321-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1847-7618-a1ea-a342213bb793",
        "storage_key": "property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7Ynx-o28uokRWb-9s3JGWqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a612770a-5a5d-40ee-8b6d-648216839a97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Chesapeake Regional Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "736 Battlefield Blvd N, Chesapeake, VA 23320, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-7da7-7655-8515-801619661459.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-7da7-7655-8515-801619661459",
        "storage_key": "property/6767906449166313/019fcdf4-7da7-7655-8515-801619661459.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://chesapeakeregional.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11523448586440372498&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chesapeake-regional-medical-center",
      "poi_latitude": "36.7473653",
      "poi_longitude": "-76.2471619",
      "poi_miles_from_property": "17.5 mi",
      "poi_walking_minutes": "6 hours 31 mins",
      "poi_biking_minutes": "1 hour 29 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 757-312-8121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1cce-731b-9e1b-ba67d307e000.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cce-731b-9e1b-ba67d307e000",
        "storage_key": "property/6767906449166313/019d0266-1cce-731b-9e1b-ba67d307e000.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJqxX4Rma7uokREnFBfm-D658",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6e4af063-d7e6-4409-a462-199d839c3fc5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Tidewater Community College - Chesapeake Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1428 Cedar Rd, Chesapeake, VA 23322, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-4007-743f-b612-248c2df1fccd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-4007-743f-b612-248c2df1fccd",
        "storage_key": "property/6767906449166313/019fcdf4-4007-743f-b612-248c2df1fccd.webp",
        "width": 720,
        "height": 479
      },
      "poi_business_url": "https://www.tcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13381456670906503656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tidewater-community-college---chesapeake-campus",
      "poi_latitude": "36.7250759",
      "poi_longitude": "-76.2943994",
      "poi_miles_from_property": "16.5 mi",
      "poi_walking_minutes": "6 hours 3 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 757-822-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1846-7759-82b9-c047b4b6279b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1846-7759-82b9-c047b4b6279b",
        "storage_key": "property/6767906449166313/019d0266-1846-7759-82b9-c047b4b6279b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkUFGAeikuokR6NGptvF7tLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d70bc561-0e23-4680-8877-dba31dd85393",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Chesapeake City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "306 Cedar Rd, Chesapeake, VA 23322, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-7ec0-73ca-8377-e1d0926ed02e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-7ec0-73ca-8377-e1d0926ed02e",
        "storage_key": "property/6767906449166313/019fcdf4-7ec0-73ca-8377-e1d0926ed02e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofchesapeake.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5270863671434927573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chesapeake-city-hall",
      "poi_latitude": "36.7159664",
      "poi_longitude": "-76.24966359999999",
      "poi_miles_from_property": "19.4 mi",
      "poi_walking_minutes": "7 hours 9 mins",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 757-382-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-26bf-7476-9b31-15733bc24ecd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-26bf-7476-9b31-15733bc24ecd",
        "storage_key": "property/6767906449166313/019d0266-26bf-7476-9b31-15733bc24ecd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1FKQCK7uokR1d1jO5XeJUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_14ec0463-f572-4b66-90c4-0cd26c474d54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Naval Medical Center Portsmouth",
      "poi_type": "Major Employers & Offices",
      "poi_address": "620 John Paul Jones Cir, Portsmouth, VA 23708, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-7f6b-7078-91b0-2ba11dda9712.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-7f6b-7078-91b0-2ba11dda9712",
        "storage_key": "property/6767906449166313/019fcdf4-7f6b-7078-91b0-2ba11dda9712.webp",
        "width": 1280,
        "height": 597
      },
      "poi_business_url": "https://portsmouth.tricare.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4171512084572656565&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "naval-medical-center-portsmouth",
      "poi_latitude": "36.844072",
      "poi_longitude": "-76.30480399999999",
      "poi_miles_from_property": "10.9 mi",
      "poi_walking_minutes": "4 hours 3 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 757-953-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1cce-731b-9e1b-ba67d307e000.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cce-731b-9e1b-ba67d307e000",
        "storage_key": "property/6767906449166313/019d0266-1cce-731b-9e1b-ba67d307e000.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0Zgmq3mYuokRtdMzqSMw5Dk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1b7cb85f-6046-4924-aa0e-edeb5a23da5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "1530 Gilbert St",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1530 Gilbert St, Norfolk, VA 23511, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1698530004174628094&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "1530-gilbert-st",
      "poi_latitude": "36.9484036",
      "poi_longitude": "-76.3090489",
      "poi_miles_from_property": "20.7 mi",
      "poi_walking_minutes": "7 hours 31 mins",
      "poi_biking_minutes": "1 hour 43 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1847-7618-a1ea-a342213bb793",
        "storage_key": "property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb8YqKjaauokR_uQrIwpkkhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d58610d3-bc07-4ffb-9176-52356dc42be9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "5115 Hampton Blvd",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5115 Hampton Blvd, Norfolk, VA 23508, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?q=5115+Hampton+Blvd,+Norfolk,+VA+23508,+USA&ftid=0x89ba99b3aa427b3d:0x40772fd35a288a02&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "5115-hampton-blvd",
      "poi_latitude": "36.8876492",
      "poi_longitude": "-76.30307959999999",
      "poi_miles_from_property": "15.1 mi",
      "poi_walking_minutes": "5 hours 26 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1847-7618-a1ea-a342213bb793",
        "storage_key": "property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "Eik1MTE1IEhhbXB0b24gQmx2ZCwgTm9yZm9saywgVkEgMjM1MDgsIFVTQSIxEi8KFAoSCT17QqqzmbqJEc8kVc75cAgJEPsnKhQKEgk7N0eXzJu6iRG9dDCWGjTEjw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a43490c7-fdc9-441e-bcd8-cbdd973dff59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Children's Hospital of The King's Daughters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "601 Childrens Ln, Norfolk, VA 23507, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-8096-726f-b4e5-bdefb27de41e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-8096-726f-b4e5-bdefb27de41e",
        "storage_key": "property/6767906449166313/019fcdf4-8096-726f-b4e5-bdefb27de41e.webp",
        "width": 1060,
        "height": 596
      },
      "poi_business_url": "https://www.chkd.org/locations/chkd-main-hospital-emergency-center?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=4055598881103474643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-hospital-of-the-kings-daughters",
      "poi_latitude": "36.8626168",
      "poi_longitude": "-76.3017886",
      "poi_miles_from_property": "13.3 mi",
      "poi_walking_minutes": "4 hours 47 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 757-668-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1cce-731b-9e1b-ba67d307e000.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cce-731b-9e1b-ba67d307e000",
        "storage_key": "property/6767906449166313/019d0266-1cce-731b-9e1b-ba67d307e000.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJaRp_uGmYuokR0--k47FhSDg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b1724c7a-9852-4b64-8d9f-0c86bbc7fefb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Bon Secours Maryview Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3636 High St, Portsmouth, VA 23707, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-538e-76c8-bf5c-07f6ebab80fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-538e-76c8-bf5c-07f6ebab80fb",
        "storage_key": "property/6767906449166313/019fcdf4-538e-76c8-bf5c-07f6ebab80fb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bonsecours.com/locations/hospitals-medical-centers/hampton-roads/bon-secours-maryview-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=13347833568345516817&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bon-secours-maryview-medical-center",
      "poi_latitude": "36.8361964",
      "poi_longitude": "-76.3472529",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 757-398-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1847-7618-a1ea-a342213bb793",
        "storage_key": "property/6767906449166313/019d0266-1847-7618-a1ea-a342213bb793.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ49Iw_RGiuokREetEGukHPbk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_eafbf2ac-1961-41b0-a0c2-025372d7c610",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "poi_name": "Sentara Obici Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2800 Godwin Blvd, Suffolk, VA 23434, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019fcdf4-84b9-764e-93f5-cb026e950ce6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-84b9-764e-93f5-cb026e950ce6",
        "storage_key": "property/6767906449166313/019fcdf4-84b9-764e-93f5-cb026e950ce6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sentara.com/hospitalslocations/sentara-obici-hospital/directions-parking",
      "poi_directions_map_url": "https://maps.google.com/?cid=5577657240468827032&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sentara-obici-hospital",
      "poi_latitude": "36.7728376",
      "poi_longitude": "-76.581491",
      "poi_miles_from_property": "17.4 mi",
      "poi_walking_minutes": "6 hours 22 mins",
      "poi_biking_minutes": "1 hour 31 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 757-934-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019d0266-1cce-731b-9e1b-ba67d307e000.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-1cce-731b-9e1b-ba67d307e000",
        "storage_key": "property/6767906449166313/019d0266-1cce-731b-9e1b-ba67d307e000.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAAAF2YuokRmKsHYbXRZ00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_818ca6b7-a302-4dd5-aaf8-484a792485a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_ee892bbe-a7f3-4f57-876d-2a64d074705c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_4010fa3e-9f8e-4311-b9e5-6b40edb69986",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_f81ed92a-6ade-47a2-a978-28fd5267af0d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_3a612372-1d87-4443-9eb8-5158e2d32702",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_395f65ba-f8b5-4368-b363-e07321173c40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_e3000bfaa5c0eb5376fd6d02",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "rating": "5",
      "name": "Michelle Lopez",
      "text": "The property is nice and clean. Loved that it has 2 pools, laundry facility and gym. LaQuisha leasing consultant gave us a tour she was very nice and friendly. The apt showed was very nice. Very thorough and explanation of everything. Looking fwd to moving in.\n\nHow ever when day of getting keys came in the apt I applied for was a mess. The paint job was very sloppy. The stove was missing screws. The Shower wall was cracked. The knobs for shower were broke. The water came out both shower head and bottom. It was a total turn off. I chose to lose out on adm fee and not move in.",
      "date": "2025-10-14",
      "title": "false"
    },
    {
      "id": "ec_854d9e42b89f78a2d26a2e1d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "rating": "4",
      "name": "Justin Burwell",
      "text": "I lived at Chesapeake Pointe for a 15 month lease at a fairly affordable price comparable to other apartments I’ve seen. Our Leasing office was really good and Kaile S worked with us primarily. Kaile is absolutely AWESOME! Any issue we had was promptly handled once we came to her. ANY ISSUE.\nUnfortunately our main issue was Maintenance. Communication with them was horrible. Their timing was horrible. Whenever they finally got to the tasks we requested, the job was most often halfway done. Most of the time when Leasing office reassured us on a task, maintenance would almost instantly give us a different answer. Our ONLY grievance is with them. I was assured that staff changes were recently made so new residents may have a different experience hopefully.",
      "date": "2025-06-06",
      "title": "false"
    },
    {
      "id": "ec_c8b84b1c0f9673c0a26d74ca",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "rating": "5",
      "name": "Rae Rae Moore",
      "text": "I gave this property 5 stars for good reason. Not only is the complex beautiful and super accommodating, the staff is A-1. My spouse and I met with Ms.Laquishia to view a 2 bedroom about a week ago. The process was simple and straightforward. All questions were answered thoroughly and with confidence. I was beyond satisfied just from the tour. So get this, we get back to the leasing office to discuss some minor details and to my disappointment I wasn’t able to get approved. Of course I’m discouraged at this point & ready to throw myself a pity party but to my surprise Ms. Laquishia would not allow me to drop my head. This Queen took it upon herself to assist me with other options 🥹She wrote down names and phone numbers of different complexes she knew of in the area as well as gave me other resources she thought would come in handy. I am forever grateful for her and her referrals. I would recommend these apartments and definitely Ms. Laquishia to anyone new to the area seeking housing.\nI give her customer service and knowledge of the area and resources 10/10 ⭐️ I will be stopping back by there very soon to give her, her flowers 💐",
      "date": "2025-09-01",
      "title": "false"
    },
    {
      "id": "ec_425e673aa21f64bdc7e528e2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "rating": "5",
      "name": "Reid Wagner",
      "text": "Hey yall! This is my first time having a place of my own. I’ve only been living here a month but without a doubt it’s an amazing place to be. Tons of amenities and friendly people. LaQuisha was my leasing agent and she helped me with more than I thought I needed when it came to getting my first place. She was beyond friendly as well as other ladies working at the leasing office. If you are patient and respectful, there’s no reason why you shouldn’t be able to build a great relationship with the staff here. If you’re looking for a great first place, choose Chesapeake Pointe!",
      "date": "2025-08-16",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_c62a4ff6-3800-4474-aa9c-3028813efcc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/019f950b-850a-750f-8426-ef2706e66ba9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f950b-850a-750f-8426-ef2706e66ba9",
        "storage_key": "property/6767906449166313/019f950b-850a-750f-8426-ef2706e66ba9.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Chesapeake Pointe",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=649472ba55d1032a93cc850b&sourceId=1001"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_87191fd9bc3c7cf9e95ed884",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "engrain",
      "external_id": "396298",
      "name": "Transfer Fee",
      "description": "Transfer fee is 50% of rent; minimum $500",
      "amount": 500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_95a41b37f51826f8b6d6f9a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "engrain",
      "external_id": "396301",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_e02089fe3cb324da8f57f5be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "engrain",
      "external_id": "396302",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_2ac3457e70ea0afb63dda203",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "engrain",
      "external_id": "396303",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_9a8d93731459cab231d3c155",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "engrain",
      "external_id": "396304",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_4d4bab2f04a948bf90a32569",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "engrain",
      "external_id": "396305",
      "name": "Pet Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "350.00 / 300.00",
      "amount_type": "text",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_18778ee4f6943e00350b0fa9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "engrain",
      "external_id": "396306",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_4295d6f393ec718a43213a85",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "engrain",
      "external_id": "536724",
      "name": "Utility - New Account Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_9c6bd1d31824d6dcc6b9990e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "engrain",
      "external_id": "543042",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_621c85165d922957c0c54183",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "engrain",
      "external_id": "543047",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_08520636febf26965de91986",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "engrain",
      "external_id": "543049",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_1b0f3954bf786a6d885f7c27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "engrain",
      "external_id": "835095",
      "name": "Washer/Dryer Fee",
      "description": "false",
      "amount": 60,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_e2f6ae178d1c694370d52ec1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "engrain",
      "external_id": "835096",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a5c4de8de81fb28997c6dcf9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "engrain",
      "external_id": "835097",
      "name": "Late Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_2ff8e070515def5e5689e008",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "engrain",
      "external_id": "835099",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "One Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_916a663bd4e4e3ddeb3d36de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "engrain",
      "external_id": "835101",
      "name": "Amenity Fee",
      "description": "false",
      "amount": 20,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_79d0ba352348a4e831154229",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "engrain",
      "external_id": "838635",
      "name": "Yearly Pool Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 50,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Annually, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199e387-8234-750f-82dc-61627a83fc32",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-chesapeake-pointe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313"
    },
    {
      "lead_collector_id": "019c3043-405c-77ef-9734-5170a3b41ae9",
      "lead_source": "FACEBOOK_ADS",
      "name": "chesapeake-pointe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313"
    },
    {
      "lead_collector_id": "019c3043-40d5-778c-86cd-d786453e33e0",
      "lead_source": "LANDING_PAGE",
      "name": "chesapeake-pointe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-chesapeake-va-183",
      "search_query": "pet friendly apartments chesapeake va",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Chesapeake, VA",
      "h2_subtitle": "Two on-site dog parks, private patios, and 1 to 3 bedroom apartments in Western Branch, Chesapeake 23321",
      "page_copy": "Looking for pet-friendly apartments in Chesapeake, VA? Chesapeake Pointe welcomes pets in our Western Branch community on Towne Point Road. Residents get two on-site dog parks, green space for daily walks, and homes with a private balcony or patio where your pet can enjoy the fresh air.\n\nChoose from one bedroom apartments (682 to 755 sq ft), two bedrooms (830 to 1,100 sq ft), or three bedrooms (934 sq ft), with townhomes available. Select homes include vinyl plank flooring and in-home washer and dryer, so pet hair cleanup is easier. After the dog park, cool off at one of our two swimming pools or visit the fitness center and yoga studio. Ask our leasing team about our pet policy and fees, then schedule a tour of Chesapeake Pointe in Chesapeake, VA 23321.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/01a13d01-29c9-7299-8c29-1e2d9c811903.webp",
      "featured_image_media": {
        "alt_text": "Couple with dog on bed",
        "public_id": "01a13d01-29c9-7299-8c29-1e2d9c811903",
        "storage_key": "property/6767906449166313/01a13d01-29c9-7299-8c29-1e2d9c811903.webp",
        "width": 1600,
        "height": 1068
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments Chesapeake VA | Chesapeake Pointe",
      "seo_description": "Pet-friendly apartments in Chesapeake, VA with 2 dog parks, 2 pools, and a fitness center. 1 to 3 bedrooms at Chesapeake Pointe. Schedule a tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "page_item_url": "apartments-with-swimming-pools-western-branch-north-593",
      "search_query": "apartments with swimming pools western branch north",
      "category": "Amenity",
      "h1_title": "Apartments with Swimming Pools in Western Branch",
      "h2_subtitle": "Two swimming pools, a sundeck, and grilling areas at Chesapeake Pointe in Western Branch North, Chesapeake, VA",
      "page_copy": "Chesapeake Pointe offers apartments with two swimming pools in Western Branch North, Chesapeake. Spend summer afternoons poolside, soak up the sun on our sundeck, and fire up the grills in our picnic and grilling area with friends and neighbors.\n\nOur Chesapeake, VA apartments include one, two, and three bedroom floor plans from 682 to 1,100 sq ft, plus townhomes. Every home has central air and a private balcony or patio, and select homes feature upgraded kitchens, renovated bathrooms, and an in-home washer and dryer. Beyond the pools, residents enjoy a fitness center, yoga studio, two dog parks, two playgrounds, and free parking for residents and guests. Find your new home near the water and close to Churchland and Western Branch schools. Schedule a tour at 3537 Towne Point Rd, Chesapeake, VA 23321.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/01a13ccd-0b81-769b-8de2-8a1b6ce71063.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool and playground area at apartment complex",
        "public_id": "01a13ccd-0b81-769b-8de2-8a1b6ce71063",
        "storage_key": "property/6767906449166313/01a13ccd-0b81-769b-8de2-8a1b6ce71063.webp",
        "width": 1600,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pools in Western Branch | Chesapeake Pointe",
      "seo_description": "Apartments with 2 swimming pools in Western Branch, Chesapeake VA. Sundeck, grilling area, and 1 to 3 bedroom homes at Chesapeake Pointe. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "page_item_url": "fitness-center-apartment-chesapeake-23321-595",
      "search_query": "fitness center apartment chesapeake 23321",
      "category": "Amenity",
      "h1_title": "Apartments with a Fitness Center in Chesapeake 23321",
      "h2_subtitle": "Work out at home with a fitness center, yoga studio, and two pools at Chesapeake Pointe in Western Branch",
      "page_copy": "Skip the gym membership. Chesapeake Pointe offers apartments with a fitness center in Chesapeake, VA 23321, so your workout is just a short walk from your front door. Add in our yoga studio for stretching and recovery, plus two swimming pools for laps and low-impact cardio during the warmer months.\n\nStaying active is easy outside too. Our Western Branch community has two dog parks for daily walks with your pup and two playgrounds for the kids. Choose a one bedroom (682 to 755 sq ft), two bedroom (830 to 1,100 sq ft), or three bedroom (934 sq ft) apartment, each with central air and a private balcony or patio. Select homes include upgraded kitchens and an in-home washer and dryer. Short-term leases are available. Visit Chesapeake Pointe on Towne Point Road and tour our fitness center apartments in Chesapeake 23321.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/01a13d02-1c4c-7080-ba6d-a4db74e97017.webp",
      "featured_image_media": {
        "alt_text": "A woman in workout clothes meditating in a sunlit apartment.",
        "public_id": "01a13d02-1c4c-7080-ba6d-a4db74e97017",
        "storage_key": "property/6767906449166313/01a13d02-1c4c-7080-ba6d-a4db74e97017.webp",
        "width": 1600,
        "height": 1048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments 23321 | Chesapeake Pointe",
      "seo_description": "Apartments in Chesapeake, VA 23321 with a fitness center, yoga studio, and 2 pools. 1 to 3 bedrooms at Chesapeake Pointe. Schedule your tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "page_item_url": "apartments-with-dog-parks-portsmouth-city-802",
      "search_query": "apartments with dog parks portsmouth city",
      "category": "Amenity",
      "h1_title": "Apartments with Dog Parks Near Portsmouth, VA",
      "h2_subtitle": "Two on-site dog parks in Western Branch, Chesapeake, minutes from Portsmouth and Churchland",
      "page_copy": "Chesapeake Pointe offers apartments with dog parks near Portsmouth, VA, just over the line in the Western Branch area of Chesapeake. Our community has not one but two dog parks, so your dog can run, play, and socialize without a drive to the park.\n\nPet owners also love the space. Choose from one, two, and three bedroom apartments from 682 to 1,100 sq ft, plus townhomes, each with a private balcony or patio. Select homes feature vinyl plank flooring that stands up to paws and an in-home washer and dryer. When it is your turn to relax, enjoy two swimming pools, a sundeck, a fitness center, and a yoga studio. We are close to Churchland and Portsmouth shopping and dining, with public transportation within walking distance. Ask about our pet policy and schedule a tour of Chesapeake Pointe today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/01a13d03-1a58-74eb-aea7-d6cb6532cfc5.webp",
      "featured_image_media": {
        "alt_text": "Woman interacting with her pug on a grassy area in front of a building",
        "public_id": "01a13d03-1a58-74eb-aea7-d6cb6532cfc5",
        "storage_key": "property/6767906449166313/01a13d03-1a58-74eb-aea7-d6cb6532cfc5.webp",
        "width": 1600,
        "height": 1064
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dog Parks Portsmouth | Chesapeake Pointe",
      "seo_description": "Pet-friendly apartments with 2 on-site dog parks near Portsmouth, VA. 1 to 3 bedroom homes at Chesapeake Pointe in Western Branch. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "page_item_url": "apartments-with-dishwasher-near-downtown-norfolk-730",
      "search_query": "apartments with dishwasher near downtown norfolk",
      "category": "Amenity",
      "h1_title": "Apartments with a Dishwasher Near Downtown Norfolk",
      "h2_subtitle": "Updated kitchens with dishwashers and microwaves in Chesapeake, VA, a quick tunnel commute to Downtown Norfolk",
      "page_copy": "Want more space for your rent than you will find in Downtown Norfolk? Chesapeake Pointe offers apartments with a dishwasher in every kitchen, located in the Western Branch area of Chesapeake with an easy commute into Norfolk through the Downtown and Midtown Tunnels.\n\nOur kitchens are built for real cooking, with a dishwasher, and select homes include upgraded finishes and a microwave. Choose from one bedroom (682 to 755 sq ft), two bedroom (830 to 1,100 sq ft), or three bedroom (934 sq ft) layouts, plus townhomes, all with central air, large closets, and a private balcony or patio. Select homes also have an in-home washer and dryer. At home, enjoy two pools, a fitness center, a yoga studio, and two dog parks, with free parking for you and your guests. Schedule a tour at Chesapeake Pointe, 3537 Towne Point Rd, Chesapeake, VA 23321.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/01a13cce-e411-772f-9024-f5a5004856c2.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with light gray walls, wood cabinets, and granite countertops.",
        "public_id": "01a13cce-e411-772f-9024-f5a5004856c2",
        "storage_key": "property/6767906449166313/01a13cce-e411-772f-9024-f5a5004856c2.webp",
        "width": 1600,
        "height": 1068
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwashers Near Norfolk | Chesapeake Pointe",
      "seo_description": "Apartments with a dishwasher near Downtown Norfolk. Upgraded kitchens, 2 pools, and 1 to 3 bedrooms at Chesapeake Pointe in Chesapeake, VA. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-chesapeake-va-563",
      "search_query": "one bedroom apartments chesapeake va",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Chesapeake, VA",
      "h2_subtitle": "Spacious 1 bedroom apartments from 682 to 755 sq ft with a private balcony or patio in Western Branch",
      "page_copy": "Chesapeake Pointe offers one bedroom apartments in Chesapeake, VA with room to spread out. Our 1 bedroom, 1 bathroom floor plans range from 682 to 755 sq ft and include central air, large closets, a dishwasher, and a private balcony or patio. Select homes feature upgraded kitchens, renovated bathrooms, vinyl plank flooring, and an in-home washer and dryer.\n\nLocated on Towne Point Road in the Western Branch area of Chesapeake 23321, our community makes it easy to get to Chesapeake Square, Portsmouth, and Norfolk Naval Station. Residents enjoy two swimming pools, a fitness center, a yoga studio, two dog parks, and free on-site parking. Short-term leases are available, and our team offers 24-hour emergency maintenance. Check current availability for 1 bedroom apartments in Chesapeake, VA and schedule your tour of Chesapeake Pointe today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/01a13ccf-fb0e-701f-a17f-a557576a06c8.webp",
      "featured_image_media": {
        "alt_text": "Cozy living room with a white sofa, two armchairs, a black ottoman, and minimalist wall art.",
        "public_id": "01a13ccf-fb0e-701f-a17f-a557576a06c8",
        "storage_key": "property/6767906449166313/01a13ccf-fb0e-701f-a17f-a557576a06c8.webp",
        "width": 1600,
        "height": 1068
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Chesapeake, VA | Chesapeake Pointe",
      "seo_description": "1 bedroom apartments in Chesapeake, VA from 682 to 755 sq ft. Private patio, 2 pools, and a fitness center at Chesapeake Pointe. See availability today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-near-western-branch-north-71",
      "search_query": "two bedroom apartments near western branch north",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Western Branch, Chesapeake",
      "h2_subtitle": "2 bedroom apartments from 830 to 1,100 sq ft, including 1.5 bath layouts, in Chesapeake, VA 23321",
      "page_copy": "Chesapeake Pointe has two bedroom apartments in Western Branch North sized for roommates, small families, or anyone who wants a home office. Our 2 bedroom floor plans range from 830 to 1,100 sq ft, with one bath and one and a half bath options. Every home has central air, large closets, a dishwasher, and a private balcony or patio, and select homes feature upgraded kitchens and an in-home washer and dryer.\n\nFamilies appreciate our location near the Churchland and Western Branch school districts and our two on-site playgrounds. Everyone enjoys the two swimming pools, sundeck, grilling area, fitness center, yoga studio, and two dog parks. Townhomes are also available. Free parking for residents and guests and 24-hour emergency maintenance make daily life easier. Schedule a tour of our 2 bedroom apartments at 3537 Towne Point Rd, Chesapeake, VA 23321.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/01a13cd1-0365-7451-b09b-5dd90381590c.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room and dining area with a modern kitchen.",
        "public_id": "01a13cd1-0365-7451-b09b-5dd90381590c",
        "storage_key": "property/6767906449166313/01a13cd1-0365-7451-b09b-5dd90381590c.webp",
        "width": 1600,
        "height": 1068
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Western Branch | Chesapeake Pointe",
      "seo_description": "2 bedroom apartments in Western Branch, Chesapeake VA from 830 to 1,100 sq ft. Two pools, dog parks, and playgrounds at Chesapeake Pointe. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-portsmouth-city-567",
      "search_query": "three bedroom apartments portsmouth city",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near Portsmouth, VA",
      "h2_subtitle": "934 sq ft 3 bedroom apartments in Western Branch, Chesapeake, near Churchland and Western Branch schools",
      "page_copy": "Need more room? Chesapeake Pointe offers three bedroom apartments near Portsmouth, VA in the Western Branch area of Chesapeake. Our 3 bedroom floor plan offers 934 sq ft with central air, large closets, a dishwasher, and a private balcony or patio. Select homes feature upgraded kitchens, renovated bathrooms, and an in-home washer and dryer, and townhomes are also available.\n\nFamilies choose Chesapeake Pointe for our spot near the Churchland and Western Branch school districts and for amenities the whole household will use: two playgrounds, two swimming pools, a sundeck, a grilling area, two dog parks, and a fitness center with a yoga studio. Free on-site parking for residents and guests and public transportation within walking distance make getting around simple. Check availability on our 3 bedroom apartments and schedule a tour of Chesapeake Pointe in Chesapeake, VA 23321.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/01a13cd2-01d9-7382-91f5-c1d1cc1eb02d.webp",
      "featured_image_media": {
        "alt_text": "Bedroom with a bed, closet, and full-length mirror.",
        "public_id": "01a13cd2-01d9-7382-91f5-c1d1cc1eb02d",
        "storage_key": "property/6767906449166313/01a13cd2-01d9-7382-91f5-c1d1cc1eb02d.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Near Portsmouth, VA | Chesapeake Pointe",
      "seo_description": "3 bedroom apartments near Portsmouth, VA at Chesapeake Pointe. 934 sq ft with a private patio, 2 pools, and 2 playgrounds in Western Branch. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "page_item_url": "apartments-near-old-dominion-university-chesapeake-va-22",
      "search_query": "apartments near Old Dominion University Chesapeake VA",
      "category": "School",
      "h1_title": "Apartments Near Old Dominion University (ODU)",
      "h2_subtitle": "Affordable 1 to 3 bedroom apartments in Chesapeake, VA, a short drive to Old Dominion University in Norfolk",
      "page_copy": "Chesapeake Pointe offers apartments near Old Dominion University for ODU students, faculty, and staff who want more space than off-campus housing in Norfolk. Our Western Branch community in Chesapeake is an easy commute to campus, and public transportation is within walking distance.\n\nRoommates can split a two bedroom apartment (830 to 1,100 sq ft) or a three bedroom (934 sq ft), and solo renters can choose a one bedroom (682 to 755 sq ft). Every apartment has central air, a dishwasher, high-speed internet availability, and a private balcony or patio, and select homes include an in-home washer and dryer. Study breaks are better with two swimming pools, a fitness center, a yoga studio, and a sundeck. Short-term leases are available to match the academic calendar. Schedule a tour of Chesapeake Pointe, your home near ODU.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/01a13cd8-8367-7088-8737-bbbbfc70d1c8.webp",
      "featured_image_media": {
        "alt_text": "Young boy wearing headphones and using a laptop while sitting on the floor with books.",
        "public_id": "01a13cd8-8367-7088-8737-bbbbfc70d1c8",
        "storage_key": "property/6767906449166313/01a13cd8-8367-7088-8737-bbbbfc70d1c8.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near ODU in Chesapeake, VA | Chesapeake Pointe",
      "seo_description": "Apartments near Old Dominion University with more space for less. 1 to 3 bedrooms, 2 pools, and short-term leases at Chesapeake Pointe in Chesapeake, VA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "page_item_url": "chesapeake-pointe-apartments-near-tidewater-community-college-portsmouth-661",
      "search_query": "Chesapeake Pointe apartments near Tidewater Community College Portsmouth",
      "category": "School",
      "h1_title": "Apartments Near TCC Portsmouth Campus",
      "h2_subtitle": "Chesapeake Pointe apartments in Western Branch, a short drive to the Tidewater Community College Portsmouth Campus",
      "page_copy": "Chesapeake Pointe offers apartments near the Tidewater Community College Portsmouth Campus, a short drive from our Western Branch community in Chesapeake. TCC students, instructors, and staff get a quiet place to study with easy access to class, work, and shopping at Chesapeake Square.\n\nChoose a one bedroom apartment (682 to 755 sq ft) for yourself, or split a two bedroom (830 to 1,100 sq ft) or three bedroom (934 sq ft) with roommates. Every home includes central air, a dishwasher, high-speed internet availability, and a private balcony or patio, and select homes have an in-home washer and dryer. Recharge at our two swimming pools, fitness center, and yoga studio, and bring your pet to our two dog parks. Short-term leases and online rent payment make student life easier. Schedule a tour of Chesapeake Pointe near TCC Portsmouth today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/01a13cd9-4ee9-7084-b10c-9c9847134a52.webp",
      "featured_image_media": {
        "alt_text": "Man working on a laptop in a kitchen",
        "public_id": "01a13cd9-4ee9-7084-b10c-9c9847134a52",
        "storage_key": "property/6767906449166313/01a13cd9-4ee9-7084-b10c-9c9847134a52.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near TCC Portsmouth | Chesapeake Pointe",
      "seo_description": "Apartments near Tidewater Community College Portsmouth Campus. 1 to 3 bedrooms, 2 pools, and short-term leases at Chesapeake Pointe. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "page_item_url": "western-branch-north-apartments-tcc-norfolk-258",
      "search_query": "Western Branch North apartments near Tidewater Community College Norfolk",
      "category": "School",
      "h1_title": "Western Branch Apartments Near TCC Norfolk Campus",
      "h2_subtitle": "Live in Western Branch, Chesapeake and commute to the Tidewater Community College Norfolk Campus downtown",
      "page_copy": "Attending the Tidewater Community College Norfolk Campus but want more space and a quieter neighborhood? Chesapeake Pointe offers Western Branch North apartments in Chesapeake with an easy commute to downtown Norfolk through the Downtown and Midtown Tunnels, plus public transportation within walking distance.\n\nOur one bedroom (682 to 755 sq ft), two bedroom (830 to 1,100 sq ft), and three bedroom (934 sq ft) apartments include central air, a dishwasher, high-speed internet availability, and a private balcony or patio. Select homes have an in-home washer and dryer, so laundry day fits around class. Between study sessions, enjoy two swimming pools, a sundeck, a fitness center, and a yoga studio. Short-term leases are available and free parking is included. Schedule a tour of Chesapeake Pointe, your Western Branch home near TCC Norfolk.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/01a13cff-d495-73c9-92f0-76fcb16b5e62.webp",
      "featured_image_media": {
        "alt_text": "A young Black woman wearing headphones sits on a couch, writing in a notebook and looking at a laptop.",
        "public_id": "01a13cff-d495-73c9-92f0-76fcb16b5e62",
        "storage_key": "property/6767906449166313/01a13cff-d495-73c9-92f0-76fcb16b5e62.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near TCC Norfolk Campus | Chesapeake Pointe",
      "seo_description": "Western Branch apartments near TCC Norfolk Campus. 1 to 3 bedrooms, 2 pools, a fitness center, and short-term leases at Chesapeake Pointe. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "page_item_url": "apartments-near-naval-medical-center-portsmouth-chesapeake-va-205",
      "search_query": "apartments near Naval Medical Center Portsmouth Chesapeake VA",
      "category": "Hospital",
      "h1_title": "Apartments Near Naval Medical Center Portsmouth",
      "h2_subtitle": "Military-friendly 1 to 3 bedroom apartments in Chesapeake, VA, a short drive to NMCP",
      "page_copy": "Chesapeake Pointe offers apartments near Naval Medical Center Portsmouth for military members, medical staff, and civilian employees who want a short commute and a comfortable place to come home to. Our Western Branch community in Chesapeake is also close to Norfolk Naval Station and the Churchland and Western Branch school districts.\n\nChoose from one bedroom (682 to 755 sq ft), two bedroom (830 to 1,100 sq ft), and three bedroom (934 sq ft) apartments, plus townhomes. Every home includes central air, a dishwasher, and a private balcony or patio, and select homes have an in-home washer and dryer. Short-term leases are available for PCS moves and rotations, and 24-hour emergency maintenance is on call while you work long shifts. Unwind at our two pools, fitness center, and yoga studio. Schedule a tour of Chesapeake Pointe near NMCP today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/01a13ce4-a325-74f6-9016-cf19a6948dc8.webp",
      "featured_image_media": {
        "alt_text": "Grand building with large columns and a wide staircase leading to the entrance.",
        "public_id": "01a13ce4-a325-74f6-9016-cf19a6948dc8",
        "storage_key": "property/6767906449166313/01a13ce4-a325-74f6-9016-cf19a6948dc8.webp",
        "width": 1600,
        "height": 1157
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Near Naval Medical Center Portsmouth | Chesapeake Pointe",
      "seo_description": "Apartments near Naval Medical Center Portsmouth in Chesapeake, VA. Short-term leases, 1 to 3 bedrooms, and 2 pools at Chesapeake Pointe. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "page_item_url": "apartments-close-to-sentara-norfolk-general-hospital-portsmouth-city-749",
      "search_query": "apartments close to Sentara Norfolk General Hospital Portsmouth City",
      "category": "Hospital",
      "h1_title": "Apartments Near Sentara Norfolk General Hospital",
      "h2_subtitle": "Spacious Chesapeake apartments for healthcare workers commuting to Sentara Norfolk General and the Fort Norfolk medical district",
      "page_copy": "Healthcare professionals working at Sentara Norfolk General Hospital can find more space for their money at Chesapeake Pointe. Our Western Branch community in Chesapeake offers a straightforward tunnel commute to the Fort Norfolk medical district, with free parking for residents and guests when you get home.\n\nChoose a one bedroom apartment (682 to 755 sq ft), two bedroom (830 to 1,100 sq ft), or three bedroom (934 sq ft), each with central air, a dishwasher, large closets, and a private balcony or patio. Select homes feature an in-home washer and dryer for scrubs and uniforms. After a long shift, decompress at one of our two swimming pools, the sundeck, or the yoga studio, or get a workout in at the fitness center. Short-term leases are available for travel nurses and residents. Schedule a tour of Chesapeake Pointe near Sentara Norfolk General Hospital today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/01a13cfe-ce5b-7219-b2e8-cbf01d7bb900.webp",
      "featured_image_media": {
        "alt_text": "A healthcare professional in scrubs holding a mug of coffee in a kitchen.",
        "public_id": "01a13cfe-ce5b-7219-b2e8-cbf01d7bb900",
        "storage_key": "property/6767906449166313/01a13cfe-ce5b-7219-b2e8-cbf01d7bb900.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sentara Norfolk General | Chesapeake Pointe",
      "seo_description": "Apartments near Sentara Norfolk General Hospital for healthcare workers. 1 to 3 bedrooms, 2 pools, and a fitness center at Chesapeake Pointe. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "page_item_url": "apartments-near-portsmouth-city-park-va-523",
      "search_query": "apartments near Portsmouth City Park VA",
      "category": "Park",
      "h1_title": "Apartments Near Portsmouth City Park, VA",
      "h2_subtitle": "Western Branch apartments in Chesapeake with two pools, two dog parks, and quick access to Portsmouth City Park",
      "page_copy": "Chesapeake Pointe offers apartments near Portsmouth City Park, VA for residents who love the outdoors. From our Western Branch community in Chesapeake, it is a short drive to Portsmouth City Park for walking trails, fishing, picnics, and weekends outside with family.\n\nYou do not have to leave home for fresh air either. Our community has two swimming pools, a sundeck, a grilling area, two dog parks, and two playgrounds. Choose from one bedroom (682 to 755 sq ft), two bedroom (830 to 1,100 sq ft), and three bedroom (934 sq ft) apartments, plus townhomes, each with central air and a private balcony or patio. Select homes include upgraded kitchens and an in-home washer and dryer. A fitness center and yoga studio round out the amenities. Schedule a tour of Chesapeake Pointe, near Portsmouth City Park, at 3537 Towne Point Rd, Chesapeake, VA 23321.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/01a13ce2-5109-77ab-8221-1380cc913379.webp",
      "featured_image_media": {
        "alt_text": "Couple walking hand-in-hand on a boardwalk by the water during fall",
        "public_id": "01a13ce2-5109-77ab-8221-1380cc913379",
        "storage_key": "property/6767906449166313/01a13ce2-5109-77ab-8221-1380cc913379.webp",
        "width": 1600,
        "height": 970
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Portsmouth City Park | Chesapeake Pointe",
      "seo_description": "Apartments near Portsmouth City Park, VA. 1 to 3 bedrooms with 2 dog parks, 2 pools, and playgrounds at Chesapeake Pointe in Western Branch. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "page_item_url": "chesapeake-apartments-close-to-town-point-park-540",
      "search_query": "Chesapeake apartments close to Town Point Park",
      "category": "Park",
      "h1_title": "Chesapeake Apartments Near Town Point Park",
      "h2_subtitle": "Live in Chesapeake and head to Town Point Park and the Norfolk waterfront for festivals and events",
      "page_copy": "Chesapeake Pointe gives you Chesapeake living with easy access to Town Point Park on the downtown Norfolk waterfront. From our Western Branch community, head through the tunnel for festivals, concerts, and riverfront walks, then come home to more space and free parking.\n\nOur Chesapeake apartments include one bedroom (682 to 755 sq ft), two bedroom (830 to 1,100 sq ft), and three bedroom (934 sq ft) floor plans, plus townhomes. Every home features central air, a dishwasher, large closets, and a private balcony or patio, and select homes include upgraded kitchens and an in-home washer and dryer. On weekends you are not downtown, enjoy our two swimming pools, sundeck, grilling area, fitness center, yoga studio, and two dog parks. Schedule a tour of Chesapeake Pointe, Chesapeake apartments close to Town Point Park, at 3537 Towne Point Rd, Chesapeake, VA 23321.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/01a13cf7-2687-75cd-855a-c2518d525db7.webp",
      "featured_image_media": {
        "alt_text": "Waterfront cityscape at sunset with purple clouds and reflections",
        "public_id": "01a13cf7-2687-75cd-855a-c2518d525db7",
        "storage_key": "property/6767906449166313/01a13cf7-2687-75cd-855a-c2518d525db7.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Town Point Park, Norfolk | Chesapeake Pointe",
      "seo_description": "Chesapeake apartments near Town Point Park and the Norfolk waterfront. 1 to 3 bedrooms, 2 pools, and free parking at Chesapeake Pointe. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "page_item_url": "rentals-near-bennetts-creek-park-boat-ramp-portsmouth-city-914",
      "search_query": "rentals near Bennett's Creek Park & Boat Ramp Portsmouth City",
      "category": "Park",
      "h1_title": "Rentals Near Bennett's Creek Park & Boat Ramp",
      "h2_subtitle": "Western Branch apartments for boaters, anglers, and outdoor lovers near Bennett's Creek Park and the Nansemond River",
      "page_copy": "Love being on the water? Chesapeake Pointe offers rentals near Bennett's Creek Park & Boat Ramp, a short drive west of our Western Branch community in Chesapeake. Launch your boat or kayak on Bennett's Creek, or spend the afternoon fishing and picnicking at the park.\n\nBack home, keep the outdoor lifestyle going with our two swimming pools, sundeck, grilling area, two dog parks, and two playgrounds. Choose a one bedroom (682 to 755 sq ft), two bedroom (830 to 1,100 sq ft), or three bedroom (934 sq ft) apartment, plus townhomes, each with central air and a private balcony or patio. Select homes feature an in-home washer and dryer for muddy gear. Free on-site and guest parking and a fitness center with a yoga studio complete the package. Schedule a tour of Chesapeake Pointe, rentals near Bennett's Creek Park, today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/01a13ce1-a501-728c-8b64-e51fb84625ef.webp",
      "featured_image_media": {
        "alt_text": "Kayaks lined up on a grassy shore of a calm lake with reeds and trees in the background.",
        "public_id": "01a13ce1-a501-728c-8b64-e51fb84625ef",
        "storage_key": "property/6767906449166313/01a13ce1-a501-728c-8b64-e51fb84625ef.webp",
        "width": 1600,
        "height": 1067
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Bennett's Creek Park | Chesapeake Pointe",
      "seo_description": "Apartment rentals near Bennett's Creek Park & Boat Ramp. 1 to 3 bedrooms, 2 pools, and free parking at Chesapeake Pointe in Western Branch. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166313",
      "source": "custom",
      "page_item_url": "apartments-near-evmc-fort-norfolk-station-chesapeake-va-580",
      "search_query": "apartments near EVMC Fort Norfolk Station Chesapeake VA",
      "category": "Transit",
      "h1_title": "Apartments Near EVMC/Fort Norfolk Station",
      "h2_subtitle": "Chesapeake apartments for Fort Norfolk medical district commuters with free parking and public transit nearby",
      "page_copy": "Chesapeake Pointe offers apartments for commuters heading to the EVMC/Fort Norfolk Station area, home to Eastern Virginia Medical Center and Sentara Norfolk General Hospital. Our Western Branch community in Chesapeake has public transportation within walking distance and a straightforward tunnel drive into Norfolk.\n\nChoose a one bedroom (682 to 755 sq ft), two bedroom (830 to 1,100 sq ft), or three bedroom (934 sq ft) apartment, plus townhomes. Each home includes central air, a dishwasher, high-speed internet availability, and a private balcony or patio, and select homes feature an in-home washer and dryer. After classes or shifts in the medical district, unwind at our two swimming pools, sundeck, fitness center, or yoga studio. Short-term leases are available for students and residents. Schedule a tour of Chesapeake Pointe, your home near EVMC/Fort Norfolk Station.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166313/01a13cf8-18b3-7369-a90d-9aa33eb498eb.webp",
      "featured_image_media": {
        "alt_text": "City skyline with modern buildings on a waterfront at sunset.",
        "public_id": "01a13cf8-18b3-7369-a90d-9aa33eb498eb",
        "storage_key": "property/6767906449166313/01a13cf8-18b3-7369-a90d-9aa33eb498eb.webp",
        "width": 1600,
        "height": 1066
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near EVMC Fort Norfolk | Chesapeake Pointe",
      "seo_description": "Apartments near EVMC/Fort Norfolk Station for medical district commuters. 1 to 3 bedrooms, 2 pools, and free parking at Chesapeake Pointe. Tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5051"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976238046"
    },
    {
      "ID": "custom_fee_guide",
      "type": "BOOLEAN",
      "value": "true"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973271"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PPS65SXX"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://livechesapeakepointe.fatwin.com/api/websites/resources/1?x=M3Q5OFcySXpVNVNTZFlmdDlYS0d6K3Q0UUV1aEtHblhoWktCM3hNMHdvYUsrMkM5QmVkMVYzYmJYeWZLd0tnWjhmNStLRVFxUVVNMFBwMjdSNUtWaHc9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Belmont"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/jlw0qjzgp2y"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "9549b94c-43e6-11ef-8609-b38ef193017f"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549b94c-43e6-11ef-8609-b38ef193017f/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549b94c-43e6-11ef-8609-b38ef193017f/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IndZejJwZ2IzeDdqL0MvZ08rL1p2Znc9PSIsInZhbHVlIjoia0tIaG85U2V1NGxoTnF1YTdtVGRPUT09IiwibWFjIjoiZjY2NDI2OGQyODEyMGY0NGJkZTBjMGFjZGI1Y2YwMDQ5NWJlYjM4MTZlYjQzYTEzMDFhN2ZiNjAyYTE4MWYxMyJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5051",
  "custom_repli_id": "9976238046",
  "custom_fee_guide": "true",
  "custom_realpage_id": "4973271",
  "custom_google_gtm_id": "GTM-PPS65SXX",
  "custom_perq_script_url": "https://livechesapeakepointe.fatwin.com/api/websites/resources/1?x=M3Q5OFcySXpVNVNTZFlmdDlYS0d6K3Q0UUV1aEtHblhoWktCM3hNMHdvYUsrMkM5QmVkMVYzYmJYeWZLd0tnWjhmNStLRVFxUVVNMFBwMjdSNUtWaHc9PQ2",
  "custom_vibesites_theme": "Belmont",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/jlw0qjzgp2y",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "9549b94c-43e6-11ef-8609-b38ef193017f",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549b94c-43e6-11ef-8609-b38ef193017f/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549b94c-43e6-11ef-8609-b38ef193017f/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IndZejJwZ2IzeDdqL0MvZ08rL1p2Znc9PSIsInZhbHVlIjoia0tIaG85U2V1NGxoTnF1YTdtVGRPUT09IiwibWFjIjoiZjY2NDI2OGQyODEyMGY0NGJkZTBjMGFjZGI1Y2YwMDQ5NWJlYjM4MTZlYjQzYTEzMDFhN2ZiNjAyYTE4MWYxMyJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "f2b10b1b-19f9-4ad9-864a-caca831ec4ca",
  "custom_audioeye_site_hash": "060f8ade9b15acfe4efd2d056065d36d"
};

export const generatedAt = '2026-10-22T20:07:43.396Z';
